import React, { useState, useEffect } from 'react';
import {
  Calendar,
  CheckSquare,
  Briefcase,
  Plus,
  Clock,
  User,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  ChevronUp,
  Filter,
  Search,
  MoreHorizontal,
  Circle,
  CheckCircle2,
  AlertCircle,
  Trash2,
  Edit2,
  X,
  StickyNote,
  ExternalLink,
  Link2,
  Wrench,
  Settings,
  Cog,
  GraduationCap,
  MessageSquare,
  FileText,
  Maximize2,
  Minimize2,
  Bell,
  Save,
  RotateCcw,
  Info,
  LayoutGrid,
  List,
  Grid3X3,
  Archive,
  ArrowUpRight,
  Upload,
  Download,
  FileSpreadsheet
} from 'lucide-react';

// Tabs del panel (sin Calendario - ahora está siempre visible arriba)
const TABS = [
  { id: 'tareas', label: 'TAREAS', icon: CheckSquare },
  { id: 'trabajos', label: 'TRABAJOS', icon: Briefcase },
  { id: 'instalaciones', label: 'INSTALACIONES', icon: Wrench },
  { id: 'logs', label: 'HISTORIAL', icon: Archive }
];

// Tipos de lugar para instalación
const TIPOS_LUGAR = [
  { value: 'cine', label: 'Cine' },
  { value: 'teatro', label: 'Teatro' },
  { value: 'auditorio', label: 'Auditorio' },
  { value: 'sala', label: 'Sala de eventos' },
  { value: 'otro', label: 'Otro' }
];

// Provincias de España
const PROVINCIAS = [
  'Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila', 'Badajoz', 'Barcelona',
  'Burgos', 'Cáceres', 'Cádiz', 'Cantabria', 'Castellón', 'Ciudad Real', 'Córdoba', 'Cuenca',
  'Girona', 'Granada', 'Guadalajara', 'Guipúzcoa', 'Huelva', 'Huesca', 'Islas Baleares',
  'Jaén', 'La Coruña', 'La Rioja', 'Las Palmas', 'León', 'Lleida', 'Lugo', 'Madrid', 'Málaga',
  'Murcia', 'Navarra', 'Ourense', 'Palencia', 'Pontevedra', 'Salamanca', 'Santa Cruz de Tenerife',
  'Segovia', 'Sevilla', 'Soria', 'Tarragona', 'Teruel', 'Toledo', 'Valencia', 'Valladolid',
  'Vizcaya', 'Zamora', 'Zaragoza'
];

// Estados de tareas
const TASK_STATUS = {
  pending: { label: 'Pendiente', color: 'text-yellow-600', bg: 'bg-yellow-50', border: 'border-yellow-200', icon: Circle },
  in_progress: { label: 'En progreso', color: 'text-blue-600', bg: 'bg-blue-50', border: 'border-blue-200', icon: AlertCircle },
  completed: { label: 'Completada', color: 'text-green-600', bg: 'bg-green-50', border: 'border-green-200', icon: CheckCircle2 }
};

// Prioridades
const PRIORITIES = {
  high: { label: 'Alta', color: 'text-red-600', bg: 'bg-red-50' },
  medium: { label: 'Media', color: 'text-yellow-600', bg: 'bg-yellow-50' },
  low: { label: 'Baja', color: 'text-green-600', bg: 'bg-green-50' }
};

// Tipos de trabajo (iconos minimalistas estilo Apple)
const JOB_TYPES = [
  { id: 'instalacion', label: 'Instalación', icon: Wrench },
  { id: 'mantenimiento', label: 'Mantenimiento', icon: Settings },
  { id: 'reparacion', label: 'Reparación', icon: Cog },
  { id: 'formacion', label: 'Formación', icon: GraduationCap },
  { id: 'consultoria', label: 'Consultoría', icon: MessageSquare },
  { id: 'otro', label: 'Otro', icon: FileText }
];

// Etiquetas de colores
const LABEL_COLORS = [
  { id: 'red', label: 'Rojo', bg: 'bg-red-500', text: 'text-white', light: 'bg-red-100 text-red-700' },
  { id: 'orange', label: 'Naranja', bg: 'bg-orange-500', text: 'text-white', light: 'bg-orange-100 text-orange-700' },
  { id: 'yellow', label: 'Amarillo', bg: 'bg-yellow-500', text: 'text-black', light: 'bg-yellow-100 text-yellow-700' },
  { id: 'green', label: 'Verde', bg: 'bg-green-500', text: 'text-white', light: 'bg-green-100 text-green-700' },
  { id: 'blue', label: 'Azul', bg: 'bg-blue-500', text: 'text-white', light: 'bg-blue-100 text-blue-700' },
  { id: 'purple', label: 'Morado', bg: 'bg-purple-500', text: 'text-white', light: 'bg-purple-100 text-purple-700' },
  { id: 'pink', label: 'Rosa', bg: 'bg-pink-500', text: 'text-white', light: 'bg-pink-100 text-pink-700' },
  { id: 'gray', label: 'Gris', bg: 'bg-gray-500', text: 'text-white', light: 'bg-gray-100 text-gray-700' }
];

// Generador de ID corto (máximo 7 dígitos: 0000001 - 9999999)
const generateShortId = () => {
  return Math.floor(Math.random() * 9999999) + 1;
};

// Festivos España 2026 (nacionales + Andalucía/Sevilla)
const HOLIDAYS_2026 = [
  { date: '2026-01-01', name: 'Año Nuevo', type: 'nacional' },
  { date: '2026-01-06', name: 'Día de Reyes', type: 'nacional' },
  { date: '2026-02-28', name: 'Día de Andalucía', type: 'autonomico' },
  { date: '2026-04-02', name: 'Jueves Santo', type: 'nacional' },
  { date: '2026-04-03', name: 'Viernes Santo', type: 'nacional' },
  { date: '2026-05-01', name: 'Día del Trabajo', type: 'nacional' },
  { date: '2026-06-04', name: 'Corpus Christi', type: 'local' },
  { date: '2026-08-15', name: 'Asunción de la Virgen', type: 'nacional' },
  { date: '2026-10-12', name: 'Fiesta Nacional', type: 'nacional' },
  { date: '2026-11-02', name: 'Todos los Santos (trasl.)', type: 'nacional' },
  { date: '2026-12-07', name: 'Día de la Constitución (trasl.)', type: 'nacional' },
  { date: '2026-12-08', name: 'Inmaculada Concepción', type: 'nacional' },
  { date: '2026-12-25', name: 'Navidad', type: 'nacional' }
];

export default function AgendaPanel({ user, department }) {
  const [activeTab, setActiveTab] = useState('tareas');
  const [tasks, setTasks] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showNewTask, setShowNewTask] = useState(false);
  const [users, setUsers] = useState([]); // Lista de usuarios para asignar tareas
  const [showNewJob, setShowNewJob] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  // Filtros por columna para tareas
  const [colFilters, setColFilters] = useState({
    id: '', tarea: '', cliente: '', estado: '', prioridad: '', fecha: '', asignado: ''
  });
  // Filtros por columna para historial
  const [logFilters, setLogFilters] = useState({
    tipo: '', titulo: '', cliente: '', tiempo: '', completado: ''
  });
  const [filterStatus, setFilterStatus] = useState(() => localStorage.getItem('agenda_filterStatus') || 'all');
  const [calendarDateFilter, setCalendarDateFilter] = useState('today'); // 'today' | 'all' - para TTI post-it

  // Modal para completar tarea/trabajo/instalación con tiempo
  const [completionModal, setCompletionModal] = useState(null); // { type: 'task'|'job'|'installation', item: {...} }
  const [archiveConfirm, setArchiveConfirm] = useState(null); // { type: 'task'|'job'|'installation'|'note', item: {...} }
  const [completionTime, setCompletionTime] = useState('');

  // Modal para convertir nota a tarea/trabajo
  const [convertNoteModal, setConvertNoteModal] = useState(null); // { note: {...}, convertTo: 'task'|'job' }

  // Función para calcular días de retraso
  const getDelayDays = (dueDate) => {
    if (!dueDate) return 0;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const due = new Date(dueDate);
    due.setHours(0, 0, 0, 0);
    const diffTime = today - due;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDateRange, setSelectedDateRange] = useState(null); // {start: Date, end: Date}
  const [calendarMonth, setCalendarMonth] = useState(new Date());
  const [calendarView, setCalendarView] = useState('month'); // 'day', 'week', 'month'
  const [viewSize, setViewSize] = useState('normal'); // 'compact', 'normal', 'large'
  const [editingTask, setEditingTask] = useState(null);
  const [editingJob, setEditingJob] = useState(null);
  // Anchos de las secciones (en porcentaje del espacio disponible)
  const [notesWidth, setNotesWidth] = useState(32); // % para NOTAS
  const [urgentWidth, setUrgentWidth] = useState(38); // % para URGENTE (calendario = 30%)
  const [notes, setNotes] = useState([]);
  const [showNewNote, setShowNewNote] = useState(false);
  const [newNoteText, setNewNoteText] = useState('');
  const [noteForSelf, setNoteForSelf] = useState(true); // true = para mí, false = para compañero
  const [noteAssignee, setNoteAssignee] = useState(''); // ID del compañero destinatario
  const [notesLoading, setNotesLoading] = useState(false);
  const [editingNote, setEditingNote] = useState(null); // Nota en edición
  const [showSentNotes, setShowSentNotes] = useState(false); // Modal de notas enviadas
  const [headerCollapsed, setHeaderCollapsed] = useState(false);
  const [selectedPriority, setSelectedPriority] = useState(() => localStorage.getItem('agenda_selectedPriority') || 'todas');
  const [urgentType, setUrgentType] = useState(() => localStorage.getItem('agenda_urgentType') || 'todos');
  const [filtersCollapsed, setFiltersCollapsed] = useState(() => localStorage.getItem('agenda_filtersCollapsed') === 'true');
  const [listViewMode, setListViewMode] = useState('table'); // 'table' o 'cards' // 'date' para fechas, 'info' para cliente/detalles // tareas, trabajos, instalaciones
  const [isResizingLeft, setIsResizingLeft] = useState(false);
  const [isResizingRight, setIsResizingRight] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(280); // Altura del panel superior
  const [isResizingHeight, setIsResizingHeight] = useState(false);
  const [layoutSaved, setLayoutSaved] = useState(false); // Feedback visual
  const [infoPopup, setInfoPopup] = useState(null); // { taskId, x, y } para mostrar popup de descripción

  // Estado para Instalaciones
  const [showNewInstallation, setShowNewInstallation] = useState(false);
  const [installations, setInstallations] = useState([]);
  const [installationTab, setInstallationTab] = useState('datos'); // datos, departamentos, material, pagos, archivos
  const [newInstallationForm, setNewInstallationForm] = useState({
    idContrato: '', // ID de instalación = número de contrato
    nombre: '',
    tipo: 'cine',
    localidad: '',
    provincia: '',
    direccion: '',
    personaContacto: '',
    telefono: '',
    propietario: 'manantial',
    fechaFirma: new Date().toISOString().split('T')[0],
    duracionContrato: '12',
    expiraContrato: new Date(Date.now() + 365*24*60*60*1000).toISOString().split('T')[0],
    crearAlarma: true,
    numAmpliaciones: 0,
    duracionAmpliacion: '12',
    deptEntradas: true,
    deptDiseno: true,
    deptSAT: true,
    deptComercial: true,
    deptAdministracion: true,
    materialInstalar: '',
    ponemosInternet: false,
    llevaPapel: false,
    tiposPapel: [], // Array: rollo, entradas_bonitas
    cantidadPapel: '',
    llevaWeb: false,
    // Diseño
    dibujarTeatro: false,
    disenoEntradas: false,
    disenoCarteleria: false,
    disenoWeb: false,
    notasDiseño: '',
    // Entradas
    numTaquillas: '',
    numGuias: '',
    numLectoristas: '',
    notasEntradas: '',
    // Administración
    dineroDestino: 'manantial',
    llevaPinpad: false,
    formaPago: 'transferencia', // transferencia, domiciliacion, efectivo
    facturacionMensual: false,
    tipoComision: 'fijo', // fijo, porcentaje
    comisionValor: '',
    // Pagos
    tipoPago: 'mensual',
    importeMensual: '',
    // Instalación
    internetTipo: 'manantial', // propio, manantial
    tipoFibra: '', // solo si internet es manantial
    queLlevar: '', // qué hay que llevar para la instalación
    fechaPrevistaInstalacion: '',
    fechaFormacion: '',
    archivos: [],
    compartirCon: [],
    notas: ''
  });

  // Validación del formulario de instalación
  const isInstallationFormValid = () => {
    const f = newInstallationForm;
    return (
      f.idContrato.trim() !== '' &&
      f.nombre.trim() !== '' &&
      f.tipo !== '' &&
      f.localidad.trim() !== '' &&
      f.provincia !== '' &&
      f.direccion.trim() !== '' &&
      f.personaContacto.trim() !== '' &&
      f.telefono.trim() !== '' &&
      f.fechaFirma !== '' &&
      f.fechaPrevistaInstalacion !== '' &&
      (f.deptEntradas || f.deptDiseno || f.deptSAT || f.deptComercial || f.deptAdministracion)
    );
  };

  // Cargar layout guardado del localStorage al montar
  useEffect(() => {
    const savedLayout = localStorage.getItem('agendaPanel_layout');
    if (savedLayout) {
      try {
        const layout = JSON.parse(savedLayout);
        if (layout.notesWidth) setNotesWidth(layout.notesWidth);
        if (layout.urgentWidth) setUrgentWidth(layout.urgentWidth);
        if (layout.headerHeight) setHeaderHeight(layout.headerHeight);
        if (layout.headerCollapsed !== undefined) setHeaderCollapsed(layout.headerCollapsed);
      } catch (e) {
        console.error('Error loading saved layout:', e);
      }
    }
  }, []);

  // Guardar filtros en localStorage cuando cambian
  useEffect(() => {
    localStorage.setItem('agenda_filterStatus', filterStatus);
  }, [filterStatus]);

  useEffect(() => {
    localStorage.setItem('agenda_selectedPriority', selectedPriority);
  }, [selectedPriority]);

  useEffect(() => {
    localStorage.setItem('agenda_urgentType', urgentType);
  }, [urgentType]);

  useEffect(() => {
    localStorage.setItem('agenda_filtersCollapsed', filtersCollapsed.toString());
  }, [filtersCollapsed]);

  // Guardar layout actual en localStorage
  const saveLayout = () => {
    const layout = {
      notesWidth,
      urgentWidth,
      headerHeight,
      headerCollapsed
    };
    localStorage.setItem('agendaPanel_layout', JSON.stringify(layout));
    setLayoutSaved(true);
    setTimeout(() => setLayoutSaved(false), 2000); // Feedback 2 segundos
  };

  // Restaurar layout por defecto
  const resetLayout = () => {
    setNotesWidth(32);
    setUrgentWidth(38);
    setHeaderHeight(280);
    setHeaderCollapsed(false);
    localStorage.removeItem('agendaPanel_layout');
  };

  // Form states for new task
  const [newTaskForm, setNewTaskForm] = useState({
    title: '',
    description: '',
    priority: 'media',
    dueDate: new Date().toISOString().split('T')[0],
    dueTime: '09:00',
    assignee: '',
    notes: '',
    trelloLink: '',
    labels: [] // Colores de etiqueta
  });

  // Form states for new job
  const [newJobForm, setNewJobForm] = useState({
    title: '',
    client: '',
    description: '',
    startDate: new Date().toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0],
    type: 'instalacion',
    status: 'pending',
    labels: [],
    notes: '',
    trelloLink: ''
  });

  // Cargar tareas reales desde API
  const loadTasks = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/tasks', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        // Mapear campos del backend al formato del frontend
        const mappedTasks = (data.tasks || []).map(t => ({
          id: t.id,
          title: t.title,
          status: t.status === 'pendiente' ? 'pending' : t.status === 'en_progreso' ? 'in_progress' : t.status === 'completada' ? 'completed' : t.status,
          priority: t.priority === 'alta' ? 'high' : t.priority === 'media' ? 'medium' : t.priority === 'baja' ? 'low' : t.priority,
          dueDate: t.due_date,
          assignee: t.assigned_to_name || 'Sin asignar'
        }));
        setTasks(mappedTasks);
      }
    } catch (error) {
      console.error('Error cargando tareas:', error);
    }
    setLoading(false);
  };

  // Cargar instalaciones desde API
  const loadInstallations = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/installations', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        // Mapear campos snake_case a camelCase
        const mapped = (data.installations || []).map(i => ({
          id: i.id,
          idContrato: i.id_contrato,
          nombre: i.nombre,
          tipo: i.tipo,
          localidad: i.localidad,
          provincia: i.provincia,
          direccion: i.direccion,
          personaContacto: i.persona_contacto,
          telefono: i.telefono,
          propietario: i.propietario,
          fechaFirma: i.fecha_firma,
          duracionContrato: i.duracion_contrato,
          crearAlarma: i.crear_alarma,
          numAmpliaciones: i.num_ampliaciones,
          duracionAmpliacion: i.duracion_ampliacion,
          deptEntradas: i.dept_entradas,
          deptDiseno: i.dept_diseno,
          deptSAT: i.dept_sat,
          deptComercial: i.dept_comercial,
          materialInstalar: i.material_instalar,
          ponemosInternet: i.ponemos_internet,
          llevaPapel: i.lleva_papel,
          tiposPapel: i.tipos_papel || [],
          cantidadPapel: i.cantidad_papel,
          llevaWeb: i.lleva_web,
          dineroDestino: i.dinero_destino,
          tipoPago: i.tipo_pago,
          importeMensual: i.importe_mensual,
          fechaPrevistaInstalacion: i.fecha_prevista_instalacion,
          notas: i.notas,
          status: i.status,
          createdAt: i.created_at
        }));
        setInstallations(mapped);
      }
    } catch (error) {
      console.error('Error cargando instalaciones:', error);
    }
  };

  // Actualizar estado de tarea
  const updateTaskStatus = async (taskId, newStatus, timeSpentMinutes = null) => {
    try {
      const token = localStorage.getItem('token');
      const backendStatus = newStatus === 'pending' ? 'pendiente' : newStatus === 'in_progress' ? 'en_progreso' : 'completada';
      const body = { status: backendStatus };
      if (timeSpentMinutes !== null && newStatus === 'completed') {
        body.time_spent = timeSpentMinutes;
        body.completed_at = new Date().toISOString();
      }
      await fetch(`/api/tasks/${taskId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(body)
      });
      loadTasks(); // Recargar
    } catch (error) {
      console.error('Error actualizando tarea:', error);
    }
  };

  // Eliminar tarea
  const deleteTask = async (taskId) => {
    if (!window.confirm('¿Eliminar esta tarea?')) return;
    try {
      const token = localStorage.getItem('token');
      await fetch(`/api/tasks/${taskId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      loadTasks(); // Recargar
    } catch (error) {
      console.error('Error eliminando tarea:', error);
    }
  };

  // Abrir modal editar tarea
  const openEditTask = (task) => {
    const dueDate = task.dueDate ? new Date(task.dueDate) : new Date();
    setNewTaskForm({
      title: task.title || '',
      description: task.description || '',
      priority: task.priority === 'high' ? 'alta' : task.priority === 'medium' ? 'media' : task.priority === 'low' ? 'baja' : task.priority || 'media',
      dueDate: dueDate.toISOString().split('T')[0],
      dueTime: dueDate.toTimeString().slice(0, 5) || '09:00',
      assignee: task.assignee || '',
      notes: task.notes || '',
      trelloLink: task.trelloLink || '',
      labels: task.labels || []
    });
    setEditingTask(task);
    setShowNewTask(true);
  };

  // Guardar tarea editada
  const updateTask = async () => {
    if (!newTaskForm.title.trim()) {
      alert('El título es obligatorio');
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const dueDateTime = `${newTaskForm.dueDate}T${newTaskForm.dueTime}:00`;
      await fetch(`/api/tasks/${editingTask.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          title: newTaskForm.title,
          description: newTaskForm.description,
          priority: newTaskForm.priority,
          due_date: dueDateTime,
          assigned_to: newTaskForm.assignee || null,
          notes: newTaskForm.notes,
          trello_link: newTaskForm.trelloLink
        })
      });
      closeTaskModal();
      loadTasks();
    } catch (error) {
      console.error('Error actualizando tarea:', error);
      alert('Error al actualizar la tarea');
    }
  };

  // Cerrar modal de tarea
  const closeTaskModal = () => {
    setShowNewTask(false);
    setEditingTask(null);
    setNewTaskForm({
      title: '',
      description: '',
      priority: 'media',
      dueDate: new Date().toISOString().split('T')[0],
      dueTime: '09:00',
      assignee: '',
      notes: '',
      trelloLink: '',
      labels: []
    });
  };

  // Abrir modal editar trabajo
  const openEditJob = (job) => {
    setNewJobForm({
      title: job.title || '',
      client: job.client || '',
      description: job.description || '',
      startDate: job.startDate || job.date || new Date().toISOString().split('T')[0],
      endDate: job.endDate || job.date || new Date().toISOString().split('T')[0],
      type: job.type || 'instalacion',
      status: job.status || 'pending',
      labels: job.labels || [],
      notes: job.notes || '',
      trelloLink: job.trelloLink || ''
    });
    setEditingJob(job);
    setShowNewJob(true);
  };

  // Guardar trabajo editado
  const updateJob = () => {
    if (!newJobForm.title.trim()) {
      alert('El título es obligatorio');
      return;
    }
    setJobs(prev => prev.map(j =>
      j.id === editingJob.id
        ? { ...j, ...newJobForm }
        : j
    ));
    closeJobModal();
  };

  // Eliminar trabajo
  const deleteJob = (jobId) => {
    if (!window.confirm('¿Eliminar este trabajo?')) return;
    setJobs(prev => prev.filter(j => j.id !== jobId));
  };

  // Actualizar estado de trabajo
  const updateJobStatus = (jobId, newStatus, timeSpentMinutes = null) => {
    setJobs(prev => prev.map(j =>
      j.id === jobId
        ? {
            ...j,
            status: newStatus,
            ...(timeSpentMinutes !== null && newStatus === 'completed' ? {
              time_spent: timeSpentMinutes,
              completed_at: new Date().toISOString()
            } : {})
          }
        : j
    ));
  };

  // Actualizar estado de instalación
  const updateInstallationStatus = (instId, newStatus, timeSpentMinutes = null) => {
    setInstallations(prev => prev.map(i =>
      i.id === instId
        ? {
            ...i,
            status: newStatus,
            ...(timeSpentMinutes !== null && newStatus === 'completed' ? {
              time_spent: timeSpentMinutes,
              completed_at: new Date().toISOString()
            } : {})
          }
        : i
    ));
  };

  // Cerrar modal de trabajo
  const closeJobModal = () => {
    setShowNewJob(false);
    setEditingJob(null);
    setNewJobForm({
      title: '',
      client: '',
      description: '',
      startDate: new Date().toISOString().split('T')[0],
      endDate: new Date().toISOString().split('T')[0],
      type: 'instalacion',
      status: 'pending',
      labels: [],
      notes: '',
      trelloLink: ''
    });
  };

  // Toggle label en trabajo
  const toggleJobLabel = (labelId) => {
    setNewJobForm(prev => ({
      ...prev,
      labels: prev.labels.includes(labelId)
        ? prev.labels.filter(l => l !== labelId)
        : [...prev.labels, labelId]
    }));
  };

  // Toggle label en tarea
  const toggleTaskLabel = (labelId) => {
    setNewTaskForm(prev => ({
      ...prev,
      labels: prev.labels.includes(labelId)
        ? prev.labels.filter(l => l !== labelId)
        : [...prev.labels, labelId]
    }));
  };

  // Cargar notas desde la API
  const loadNotes = async () => {
    try {
      setNotesLoading(true);
      const token = localStorage.getItem('token');
      const response = await fetch('/api/notes', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        setNotes(data.notes || []);
      }
    } catch (error) {
      console.error('Error cargando notas:', error);
    } finally {
      setNotesLoading(false);
    }
  };

  // Añadir nota (rápida o para compañero)
  const addNote = async () => {
    if (!newNoteText.trim()) return;
    if (!noteForSelf && !noteAssignee) {
      alert('Selecciona un compañero destinatario');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/notes', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          text: newNoteText.trim(),
          date: selectedDate.toISOString().split('T')[0],
          assignedTo: noteForSelf ? null : noteAssignee,
          color: 'yellow'
        })
      });
      const data = await response.json();
      if (data.success) {
        setNotes(prev => [data.note, ...prev]);
        setNewNoteText('');
        setNoteForSelf(true);
        setNoteAssignee('');
        setShowNewNote(false);
      }
    } catch (error) {
      console.error('Error creando nota:', error);
    }
  };

  // Obtener notas para mostrar en el post-it (propias + recibidas, NO las enviadas a otros)
  const getNotesForSelectedDate = () => {
    const selectedDateStr = selectedDate.toISOString().split('T')[0];
    return notes.filter(n => {
      const noteDate = n.date?.split('T')[0] || n.date;
      if (noteDate !== selectedDateStr) return false;

      // Nota propia (para mí mismo) - created_by = yo, assigned_to = null
      const isMyOwnNote = n.created_by === user?.id && !n.assigned_to;
      // Nota recibida de otro - assigned_to = yo
      const isReceivedNote = n.assigned_to === user?.id;

      return isMyOwnNote || isReceivedNote;
    });
  };

  // Obtener tareas urgentes del día seleccionado
  const getUrgentTasksForSelectedDate = () => {
    const selectedDateStr = selectedDate.toISOString().split('T')[0];
    return tasks.filter(task => {
      if (task.completed) return false;
      if (task.priority !== 'alta') return false;
      if (task.dueDate) {
        const taskDateStr = new Date(task.dueDate).toISOString().split('T')[0];
        return taskDateStr === selectedDateStr;
      }
      return false;
    });
  };

  // Eliminar nota
  const deleteNote = async (noteId) => {
    try {
      const token = localStorage.getItem('token');
      await fetch(`/api/notes/${noteId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setNotes(prev => prev.filter(n => n.id !== noteId));
    } catch (error) {
      console.error('Error eliminando nota:', error);
    }
  };

  // Marcar nota como leída
  const markNoteAsRead = async (noteId) => {
    try {
      const token = localStorage.getItem('token');
      await fetch(`/api/notes/${noteId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ is_read: true })
      });
      setNotes(prev => prev.map(n => n.id === noteId ? { ...n, is_read: true } : n));
    } catch (error) {
      console.error('Error marcando nota como leída:', error);
    }
  };

  // Marcar nota como completada/pendiente
  const toggleNoteCompleted = (noteId) => {
    setNotes(prev => prev.map(n => {
      if (n.id === noteId) {
        const newStatus = n.is_completed ? false : true;
        return {
          ...n,
          is_completed: newStatus,
          completed_at: newStatus ? new Date().toISOString() : null
        };
      }
      return n;
    }));
  };

  // Obtener notas enviadas a compañeros (para el historial)
  const getSentNotes = () => {
    return notes.filter(n => n.created_by === user?.id && n.assigned_to && n.assigned_to !== user?.id);
  };

  // Convertir nota a tarea
  const convertNoteToTask = (note) => {
    const newTask = {
      id: crypto.randomUUID ? crypto.randomUUID() : `task-${Date.now()}`,
      title: note.text.slice(0, 100), // Limitar el título
      description: note.text.length > 100 ? note.text : '',
      dueDate: selectedDate.toISOString().split('T')[0],
      priority: 'media',
      status: 'pending',
      assignee: user?.name || '',
      notes: `Convertido desde nota del ${new Date(note.date || note.created_at).toLocaleDateString('es-ES')}`
    };
    setTasks(prev => [newTask, ...prev]);
    deleteNote(note.id);
    setActiveTab('tareas');
  };

  // Convertir nota a trabajo
  const convertNoteToJob = (note) => {
    const today = selectedDate.toISOString().split('T')[0];
    const newJob = {
      id: crypto.randomUUID ? crypto.randomUUID() : `job-${Date.now()}`,
      title: note.text.slice(0, 100),
      description: note.text.length > 100 ? note.text : '',
      client: '',
      startDate: today,
      endDate: today,
      type: 'otro',
      status: 'pending',
      priority: 'media',
      labels: [],
      notes: `Convertido desde nota del ${new Date(note.date || note.created_at).toLocaleDateString('es-ES')}`
    };
    setJobs(prev => [newJob, ...prev]);
    deleteNote(note.id);
    setActiveTab('trabajos');
  };

  // ===== FUNCIONES DE EXCEL =====

  // Descargar plantilla de tareas
  const downloadTaskTemplate = () => {
    const headers = ['titulo', 'descripcion', 'fecha', 'prioridad', 'asignado'];
    const example = ['Revisar documentación', 'Revisar toda la documentación del proyecto', '2026-01-30', 'media', 'Juan'];
    const csv = [headers.join(';'), example.join(';')].join('\n');
    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'plantilla_tareas.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  // Exportar tareas a CSV
  const exportTasksToExcel = () => {
    const headers = ['titulo', 'descripcion', 'fecha', 'prioridad', 'estado', 'asignado'];
    const rows = tasks.map(t => [
      t.title || '',
      (t.description || '').replace(/;/g, ',').replace(/\n/g, ' '),
      t.dueDate || '',
      t.priority || 'media',
      t.status || 'pending',
      t.assignee || ''
    ].join(';'));
    const csv = [headers.join(';'), ...rows].join('\n');
    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `tareas_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Importar tareas desde CSV
  const handleTasksUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target?.result;
      const lines = text.split('\n').filter(l => l.trim());
      if (lines.length < 2) return alert('El archivo está vacío o no tiene datos');
      const newTasks = [];
      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(';');
        if (cols.length >= 3 && cols[0].trim()) {
          newTasks.push({
            id: crypto.randomUUID ? crypto.randomUUID() : `task-${Date.now()}-${i}`,
            title: cols[0].trim(),
            description: cols[1]?.trim() || '',
            dueDate: cols[2]?.trim() || new Date().toISOString().split('T')[0],
            priority: cols[3]?.trim() || 'media',
            status: 'pending',
            assignee: cols[4]?.trim() || user?.name || ''
          });
        }
      }
      if (newTasks.length > 0) {
        setTasks(prev => [...newTasks, ...prev]);
        alert(`Se importaron ${newTasks.length} tareas`);
      }
    };
    reader.readAsText(file);
    e.target.value = '';
  };

  // Descargar plantilla de trabajos
  const downloadJobTemplate = () => {
    const headers = ['titulo', 'cliente', 'tipo', 'fecha_inicio', 'fecha_fin', 'prioridad'];
    const example = ['Instalación servidor', 'Empresa ABC', 'instalacion', '2026-01-30', '2026-01-31', 'alta'];
    const csv = [headers.join(';'), example.join(';')].join('\n');
    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'plantilla_trabajos.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  // Exportar trabajos a CSV
  const exportJobsToExcel = () => {
    const headers = ['titulo', 'cliente', 'tipo', 'fecha_inicio', 'fecha_fin', 'prioridad', 'estado'];
    const rows = jobs.map(j => [
      j.title || '',
      j.client || '',
      j.type || 'otro',
      j.startDate || '',
      j.endDate || '',
      j.priority || 'media',
      j.status || 'pending'
    ].join(';'));
    const csv = [headers.join(';'), ...rows].join('\n');
    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `trabajos_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Importar trabajos desde CSV
  const handleJobsUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target?.result;
      const lines = text.split('\n').filter(l => l.trim());
      if (lines.length < 2) return alert('El archivo está vacío o no tiene datos');
      const newJobs = [];
      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(';');
        if (cols.length >= 3 && cols[0].trim()) {
          newJobs.push({
            id: crypto.randomUUID ? crypto.randomUUID() : `job-${Date.now()}-${i}`,
            title: cols[0].trim(),
            client: cols[1]?.trim() || '',
            type: cols[2]?.trim() || 'otro',
            startDate: cols[3]?.trim() || new Date().toISOString().split('T')[0],
            endDate: cols[4]?.trim() || cols[3]?.trim() || new Date().toISOString().split('T')[0],
            priority: cols[5]?.trim() || 'media',
            status: 'pending',
            labels: []
          });
        }
      }
      if (newJobs.length > 0) {
        setJobs(prev => [...newJobs, ...prev]);
        alert(`Se importaron ${newJobs.length} trabajos`);
      }
    };
    reader.readAsText(file);
    e.target.value = '';
  };

  // Resize de la barra izquierda (entre NOTAS y CALENDARIO)
  const handleLeftResize = (e) => {
    e.preventDefault();
    setIsResizingLeft(true);
    const container = e.target.closest('.resize-container');
    const containerWidth = container?.offsetWidth || 800;
    const startX = e.clientX;
    const startWidth = notesWidth;

    const handleMouseMove = (e) => {
      const diff = e.clientX - startX;
      const diffPercent = (diff / containerWidth) * 100;
      const newWidth = Math.min(Math.max(startWidth + diffPercent, 15), 40); // Min 15%, Max 40%
      setNotesWidth(newWidth);
    };

    const handleMouseUp = () => {
      setIsResizingLeft(false);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  // Resize de la barra derecha (entre URGENTE y CALENDARIO)
  // Al arrastrar hacia la izquierda = calendario más grande (urgentWidth más pequeño)
  // Al arrastrar hacia la derecha = calendario más pequeño (urgentWidth más grande)
  const handleRightResize = (e) => {
    e.preventDefault();
    setIsResizingRight(true);
    const container = e.target.closest('.resize-container');
    const containerWidth = container?.offsetWidth || 800;
    const startX = e.clientX;
    const startWidth = urgentWidth;

    const handleMouseMove = (e) => {
      const diff = e.clientX - startX; // Invertido: hacia derecha = más urgente
      const diffPercent = (diff / containerWidth) * 100;
      const newWidth = Math.min(Math.max(startWidth + diffPercent, 15), 40); // Min 15%, Max 40%
      setUrgentWidth(newWidth);
    };

    const handleMouseUp = () => {
      setIsResizingRight(false);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  // Resize de la altura del panel superior
  const handleHeightResize = (e) => {
    e.preventDefault();
    setIsResizingHeight(true);
    const startY = e.clientY;
    const startHeight = headerHeight;

    const handleMouseMove = (e) => {
      const diff = e.clientY - startY;
      const newHeight = Math.min(Math.max(startHeight + diff, 150), 500); // Min 150px, Max 500px
      setHeaderHeight(newHeight);
    };

    const handleMouseUp = () => {
      setIsResizingHeight(false);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  // Crear nueva tarea
  const createTask = async () => {
    if (!newTaskForm.title.trim()) {
      alert('El título es obligatorio');
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const dueDateTime = `${newTaskForm.dueDate}T${newTaskForm.dueTime}:00`;
      await fetch('/api/tasks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          title: newTaskForm.title,
          description: newTaskForm.description,
          priority: newTaskForm.priority,
          due_date: dueDateTime,
          assigned_to: newTaskForm.assignee || null,
          notes: newTaskForm.notes,
          trello_link: newTaskForm.trelloLink
        })
      });
      closeTaskModal();
      loadTasks();
    } catch (error) {
      console.error('Error creando tarea:', error);
      alert('Error al crear la tarea');
    }
  };

  // Crear nuevo trabajo
  const createJob = async () => {
    if (!newJobForm.title.trim()) {
      alert('El título es obligatorio');
      return;
    }
    // Add to local jobs (would connect to API later)
    const newJob = {
      id: generateShortId(),
      title: newJobForm.title,
      client: newJobForm.client,
      description: newJobForm.description,
      startDate: newJobForm.startDate,
      endDate: newJobForm.endDate,
      type: newJobForm.type,
      status: newJobForm.status,
      labels: newJobForm.labels,
      notes: newJobForm.notes,
      trelloLink: newJobForm.trelloLink
    };
    setJobs(prev => [...prev, newJob]);
    closeJobModal();
  };

  // Cargar usuarios para el desplegable de asignar
  const loadUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/users/list', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setUsers(data.users || data || []);
      }
    } catch (error) {
      console.error('Error cargando usuarios:', error);
    }
  };

  // Cargar tareas, usuarios, notas e instalaciones al montar
  useEffect(() => {
    loadTasks();
    loadUsers();
    loadInstallations();
    loadNotes();
    // Escuchar evento de nueva tarea (socket)
    const handleNewTask = () => loadTasks();
    const handleNewNote = () => loadNotes();
    window.addEventListener('task:reload', handleNewTask);
    window.addEventListener('note:reload', handleNewNote);
    return () => {
      window.removeEventListener('task:reload', handleNewTask);
      window.removeEventListener('note:reload', handleNewNote);
    };
  }, []);

  // Trabajos de ejemplo (estos se conectarán después)
  useEffect(() => {
    setJobs([
      { id: 1, title: 'Instalación taquilla Madrid', client: 'Teatro Real', status: 'pending', startDate: '2026-01-22', endDate: '2026-01-24', type: 'instalacion', labels: ['blue', 'green'] },
      { id: 2, title: 'Mantenimiento pinpad Barcelona', client: 'Cine Comedia', status: 'in_progress', startDate: '2026-01-19', endDate: '2026-01-19', type: 'mantenimiento', labels: ['orange'] },
      { id: 3, title: 'Formación personal nuevo TPV', client: 'Auditorio Nacional', status: 'pending', startDate: '2026-01-25', endDate: '2026-01-26', type: 'formacion', labels: ['purple'] }
    ]);
  }, []);

  // Generar ID numérico para mostrar (DDMMYYXX)
  const generateDisplayId = (index) => {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, '0');
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const yy = String(now.getFullYear()).slice(-2);
    const xx = String(index + 1).padStart(2, '0');
    return `${dd}${mm}${yy}${xx}`;
  };

  // Filtro de tareas - solo filtra por búsqueda y estado válido
  const validTaskStatuses = ['all', 'pending', 'in_progress', 'completed'];
  const effectiveTaskFilter = validTaskStatuses.includes(filterStatus) ? filterStatus : 'all';

  const filteredTasks = tasks.filter((task, index) => {
    const displayId = generateDisplayId(index);
    const statusLabel = task.status === 'pending' ? 'pendiente' : task.status === 'in_progress' ? 'en progreso' : task.status === 'completed' ? 'completada' : task.status;
    const priorityLabel = task.priority === 'high' || task.priority === 'alta' ? 'alta' : task.priority === 'medium' || task.priority === 'media' ? 'media' : 'baja';
    const dateStr = task.dueDate ? new Date(task.dueDate).toLocaleDateString('es-ES') : '';
    const clienteStr = (task.cliente || task.client || '').toLowerCase();

    // Filtros por columna
    const matchesId = !colFilters.id || displayId.includes(colFilters.id);
    const matchesTarea = !colFilters.tarea || task.title?.toLowerCase().includes(colFilters.tarea.toLowerCase());
    const matchesCliente = !colFilters.cliente || clienteStr.includes(colFilters.cliente.toLowerCase());
    const matchesEstado = !colFilters.estado || statusLabel.toLowerCase().includes(colFilters.estado.toLowerCase());
    const matchesPrioridad = !colFilters.prioridad || priorityLabel.toLowerCase().includes(colFilters.prioridad.toLowerCase());
    const matchesFecha = !colFilters.fecha || dateStr.includes(colFilters.fecha);
    const matchesAsignado = !colFilters.asignado || task.assignee?.toLowerCase().includes(colFilters.asignado.toLowerCase());

    const matchesStatus = effectiveTaskFilter === 'all' || task.status === effectiveTaskFilter;
    return matchesId && matchesTarea && matchesCliente && matchesEstado && matchesPrioridad && matchesFecha && matchesAsignado && matchesStatus;
  });

  const renderTareas = () => (
    <div className="space-y-4">
      {/* Barra de acciones estilo Hetzner */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Buscar tareas..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-9 pr-4 py-2 border border-gray-500 rounded-lg text-sm focus:outline-none focus:border-[#3B82F6] w-64"
            />
          </div>
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="px-3 py-2 border border-gray-500 rounded-lg text-sm focus:outline-none focus:border-[#3B82F6]"
          >
            <option value="all">Todos los estados</option>
            <option value="pending">Pendientes</option>
            <option value="in_progress">En progreso</option>
            <option value="completed">Completadas</option>
          </select>
          {/* Botones Excel */}
          <div className="flex items-center gap-1 border-l border-gray-300 pl-3 ml-1">
            <button
              onClick={downloadTaskTemplate}
              className="flex items-center gap-1 px-2 py-1.5 text-xs text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
              title="Descargar plantilla CSV"
            >
              <FileSpreadsheet className="w-4 h-4" />
              Plantilla
            </button>
            <button
              onClick={exportTasksToExcel}
              className="flex items-center gap-1 px-2 py-1.5 text-xs text-gray-600 hover:text-green-600 hover:bg-green-50 rounded transition-colors"
              title="Exportar tareas a CSV"
            >
              <Download className="w-4 h-4" />
              Exportar
            </button>
            <label className="flex items-center gap-1 px-2 py-1.5 text-xs text-gray-600 hover:text-amber-600 hover:bg-amber-50 rounded transition-colors cursor-pointer" title="Importar tareas desde CSV">
              <Upload className="w-4 h-4" />
              Importar
              <input type="file" accept=".csv" onChange={handleTasksUpload} className="hidden" />
            </label>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {/* Toggle vista tabla/tarjetas */}
          <div className="flex items-center bg-gray-100 rounded-lg p-0.5">
            <button
              onClick={() => setListViewMode('table')}
              className={`flex items-center gap-1 px-2.5 py-1.5 rounded-md transition-all text-xs font-medium ${listViewMode === 'table' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
              title="Vista tabla"
            >
              <List className="w-3.5 h-3.5" />
              Tabla
            </button>
            <button
              onClick={() => setListViewMode('cards')}
              className={`flex items-center gap-1 px-2.5 py-1.5 rounded-md transition-all text-xs font-medium ${listViewMode === 'cards' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
              title="Vista tarjetas"
            >
              <LayoutGrid className="w-3.5 h-3.5" />
              Tarjetas
            </button>
          </div>
          <button
            onClick={() => setShowNewTask(true)}
            className="flex items-center gap-2 px-4 py-2 bg-[#3B82F6] text-white rounded-lg hover:bg-[#2563EB] transition-colors text-sm font-medium"
          >
            <Plus className="w-4 h-4" />
            Nueva tarea
          </button>
        </div>
      </div>

      {/* Vista Tabla */}
      {listViewMode === 'table' && (
      <div className="bg-white border border-gray-500 rounded-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr className="border-b border-gray-300">
              <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-24">ID</th>
              <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Tarea</th>
              <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-32">Cliente</th>
              <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-28">Estado</th>
              <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-24">Prioridad</th>
              <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-28">Fecha</th>
              <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-32">Asignado</th>
              <th className="text-right px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-28">Opciones</th>
            </tr>
            <tr className="border-b border-gray-400 bg-gray-100">
              <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={colFilters.id} onChange={(e) => setColFilters({...colFilters, id: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
              <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={colFilters.tarea} onChange={(e) => setColFilters({...colFilters, tarea: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
              <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={colFilters.cliente} onChange={(e) => setColFilters({...colFilters, cliente: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
              <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={colFilters.estado} onChange={(e) => setColFilters({...colFilters, estado: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
              <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={colFilters.prioridad} onChange={(e) => setColFilters({...colFilters, prioridad: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
              <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={colFilters.fecha} onChange={(e) => setColFilters({...colFilters, fecha: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
              <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={colFilters.asignado} onChange={(e) => setColFilters({...colFilters, asignado: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
              <th className="px-1 py-1"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {filteredTasks.map((task, index) => {
              const status = TASK_STATUS[task.status];
              const priority = PRIORITIES[task.priority];
              const StatusIcon = status.icon;
              return (
                <tr key={task.id} className={`hover:bg-gray-50 transition-colors ${task.status === 'completed' ? 'bg-green-50/50' : ''}`}>
                  <td className="px-2 py-3 text-sm text-gray-600 font-mono" title={task.id}>{generateDisplayId(index)}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-900">{task.title}</span>
                      {task.description && task.description.length > 30 && (
                        <div className="relative">
                          <button
                            onMouseEnter={(e) => {
                              const rect = e.currentTarget.getBoundingClientRect();
                              setInfoPopup({ taskId: task.id, description: task.description, x: rect.left, y: rect.bottom + 5 });
                            }}
                            onMouseLeave={() => setInfoPopup(null)}
                            onClick={(e) => {
                              e.stopPropagation();
                              const rect = e.currentTarget.getBoundingClientRect();
                              setInfoPopup(infoPopup?.taskId === task.id ? null : { taskId: task.id, description: task.description, x: rect.left, y: rect.bottom + 5 });
                            }}
                            className="p-0.5 hover:bg-blue-100 rounded-full transition-colors"
                            title="Ver descripción completa"
                          >
                            <Info className="w-4 h-4 text-blue-500" />
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600">
                    {task.cliente || task.client || '-'}
                  </td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${status.bg} ${status.color} ${status.border} border`}>
                      <StatusIcon className="w-3 h-3" />
                      {status.label}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium ${priority.bg} ${priority.color}`}>
                      {priority.label}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500">
                    {new Date(task.dueDate).toLocaleDateString('es-ES')}
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center">
                        <User className="w-3 h-3 text-gray-500" />
                      </div>
                      <span className="text-sm text-gray-600">{task.assignee}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-right">
                    <div className="flex items-center justify-end gap-1">
                      {task.notes && (
                        <span className="p-1.5" title={task.notes}>
                          <StickyNote className="w-4 h-4 text-yellow-500" />
                        </span>
                      )}
                      {task.trelloLink && (
                        <a
                          href={task.trelloLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="p-1.5 hover:bg-blue-100 rounded-lg transition-colors"
                          title="Ver en Trello"
                        >
                          <ExternalLink className="w-4 h-4 text-blue-500" />
                        </a>
                      )}
                      <button
                        onClick={() => openEditTask(task)}
                        className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
                        title="Editar"
                      >
                        <Edit2 className="w-4 h-4 text-gray-500" />
                      </button>
                      {task.status !== 'completed' && (
                        <button
                          onClick={() => setArchiveConfirm({ type: 'task', item: task })}
                          className="p-1.5 hover:bg-green-100 rounded-lg transition-colors"
                          title="Archivar"
                        >
                          <Archive className="w-4 h-4 text-green-500" />
                        </button>
                      )}
                      <button
                        onClick={() => deleteTask(task.id)}
                        className="p-1.5 hover:bg-red-100 rounded-lg transition-colors"
                        title="Eliminar"
                      >
                        <Trash2 className="w-4 h-4 text-red-400" />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {filteredTasks.length === 0 && (
          <div className="text-center py-8 text-gray-400">
            <CheckSquare className="w-12 h-12 mx-auto mb-2 opacity-50" />
            <p>No hay tareas</p>
          </div>
        )}
      </div>
      )}

      {/* Vista Tarjetas */}
      {listViewMode === 'cards' && (
        <div className="grid gap-3 md:gap-4">
          {filteredTasks.map((task, index) => {
            const status = TASK_STATUS[task.status];
            const priority = PRIORITIES[task.priority];
            const StatusIcon = status.icon;
            const displayId = generateDisplayId(index);
            return (
              <div key={task.id} className="bg-white border border-gray-500 rounded-xl p-4 hover:border-[#3B82F6] hover:shadow-md transition-all">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-start gap-3 min-w-0">
                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${priority.bg}`}>
                      <CheckSquare className={`w-5 h-5 ${priority.color}`} />
                    </div>
                    <div className="min-w-0">
                      <div className="flex items-center gap-2">
                        <span className="text-xs font-mono text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded">#{displayId}</span>
                        <h3 className="font-semibold text-gray-900 truncate">{task.title}</h3>
                      </div>
                      {task.description && <p className="text-sm text-gray-500 truncate">{task.description}</p>}
                      <p className="text-xs text-gray-400">{task.assignee}</p>
                    </div>
                  </div>
                  <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium flex-shrink-0 ${status.bg} ${status.color} ${status.border} border`}>
                    <StatusIcon className="w-3 h-3" />
                    {status.label}
                  </span>
                </div>
                <div className="flex flex-wrap items-center gap-3 mt-3 pt-3 border-t border-gray-400">
                  <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium ${priority.bg} ${priority.color}`}>
                    {priority.label}
                  </span>
                  <span className="flex items-center gap-1 text-sm text-gray-500">
                    <Calendar className="w-4 h-4" />
                    {new Date(task.dueDate).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}
                  </span>
                  {task.notes && (
                    <span className="flex items-center gap-1 text-xs text-gray-400" title={task.notes}>
                      <StickyNote className="w-3 h-3" />
                      Notas
                    </span>
                  )}
                  {task.trelloLink && (
                    <a href={task.trelloLink} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 text-xs text-blue-500 hover:underline">
                      <ExternalLink className="w-3 h-3" />
                      Trello
                    </a>
                  )}
                  <div className="flex items-center gap-1 ml-auto">
                    <button onClick={() => openEditTask(task)} className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors" title="Editar">
                      <Edit2 className="w-4 h-4 text-gray-500" />
                    </button>
                    {task.status !== 'completed' && (
                      <button onClick={() => updateTaskStatus(task.id, 'completed')} className="p-1.5 hover:bg-green-100 rounded-lg transition-colors" title="Completar">
                        <CheckCircle2 className="w-4 h-4 text-green-500" />
                      </button>
                    )}
                    <button onClick={() => deleteTask(task.id)} className="p-1.5 hover:bg-red-100 rounded-lg transition-colors" title="Eliminar">
                      <Trash2 className="w-4 h-4 text-red-400" />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
          {filteredTasks.length === 0 && (
            <div className="text-center py-12 text-gray-400">
              <CheckSquare className="w-12 h-12 mx-auto mb-2 opacity-50" />
              <p>No hay tareas</p>
            </div>
          )}
        </div>
      )}
    </div>
  );

  const renderTrabajos = () => {
    const getJobType = (typeId) => JOB_TYPES.find(t => t.id === typeId) || JOB_TYPES[5];
    const getLabelColor = (labelId) => LABEL_COLORS.find(l => l.id === labelId);

    return (
      <div className="space-y-4">
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="relative">
              <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Buscar trabajos..."
                className="pl-9 pr-4 py-2 border border-gray-500 rounded-lg text-sm focus:outline-none focus:border-[#3B82F6] w-64"
              />
            </div>
            {/* Botones Excel */}
            <div className="flex items-center gap-1 border-l border-gray-300 pl-3 ml-1">
              <button
                onClick={downloadJobTemplate}
                className="flex items-center gap-1 px-2 py-1.5 text-xs text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                title="Descargar plantilla CSV"
              >
                <FileSpreadsheet className="w-4 h-4" />
                Plantilla
              </button>
              <button
                onClick={exportJobsToExcel}
                className="flex items-center gap-1 px-2 py-1.5 text-xs text-gray-600 hover:text-green-600 hover:bg-green-50 rounded transition-colors"
                title="Exportar trabajos a CSV"
              >
                <Download className="w-4 h-4" />
                Exportar
              </button>
              <label className="flex items-center gap-1 px-2 py-1.5 text-xs text-gray-600 hover:text-amber-600 hover:bg-amber-50 rounded transition-colors cursor-pointer" title="Importar trabajos desde CSV">
                <Upload className="w-4 h-4" />
                Importar
                <input type="file" accept=".csv" onChange={handleJobsUpload} className="hidden" />
              </label>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {/* Toggle vista tabla/tarjetas */}
            <div className="flex items-center bg-gray-100 rounded-lg p-0.5">
              <button
                onClick={() => setListViewMode('table')}
                className={`flex items-center gap-1 px-2.5 py-1.5 rounded-md transition-all text-xs font-medium ${listViewMode === 'table' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
                title="Vista tabla"
              >
                <List className="w-3.5 h-3.5" />
                Tabla
              </button>
              <button
                onClick={() => setListViewMode('cards')}
                className={`flex items-center gap-1 px-2.5 py-1.5 rounded-md transition-all text-xs font-medium ${listViewMode === 'cards' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
                title="Vista tarjetas"
              >
                <LayoutGrid className="w-3.5 h-3.5" />
                Tarjetas
              </button>
            </div>
            <button
              onClick={() => setShowNewJob(true)}
              className="flex items-center justify-center gap-2 px-4 py-2 bg-[#3B82F6] text-white rounded-lg hover:bg-[#2563EB] transition-colors text-sm font-medium"
            >
              <Plus className="w-4 h-4" />
              Nuevo trabajo
            </button>
          </div>
        </div>

        
        {/* Vista Tabla */}
        {listViewMode === 'table' && (
          <div className="bg-white border border-gray-500 rounded-lg overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr className="border-b border-gray-300">
                  <th className="text-left px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Trabajo</th>
                  <th className="text-left px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Cliente</th>
                  <th className="text-left px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
                  <th className="text-left px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Fechas</th>
                  <th className="text-left px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                  <th className="text-right px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-28">Acciones</th>
                </tr>
                <tr className="border-b border-gray-400 bg-gray-100">
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {jobs.map((job) => {
                  const jobType = getJobType(job.type);
                  return (
                    <tr key={job.id} className={`hover:bg-gray-50 transition-colors ${job.status === 'completed' ? 'bg-green-50/50' : ''}`}>
                      <td className="px-4 py-3">
                        <span className="font-medium text-gray-900">{job.title}</span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">{job.client}</td>
                      <td className="px-4 py-3">
                        <span className="inline-flex items-center gap-1.5 px-2 py-1 bg-gray-50 text-gray-600 rounded-lg text-xs border border-gray-300">
                          <jobType.icon className="w-3 h-3" />
                          {jobType.label}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-500">
                        {job.startDate === job.endDate ? (
                          new Date(job.startDate).toLocaleDateString('es-ES')
                        ) : (
                          <>{new Date(job.startDate).toLocaleDateString('es-ES')} → {new Date(job.endDate).toLocaleDateString('es-ES')}</>
                        )}
                      </td>
                      <td className="px-4 py-3">
                        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${
                          job.status === 'pending' ? 'bg-yellow-50 text-yellow-600 border border-yellow-200' :
                          job.status === 'in_progress' ? 'bg-blue-50 text-blue-600 border border-blue-200' :
                          'bg-green-50 text-green-600 border border-green-200'
                        }`}>
                          {job.status === 'pending' ? 'Pendiente' : job.status === 'in_progress' ? 'En progreso' : 'Completado'}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-right">
                        <div className="flex items-center justify-end gap-1">
                          {job.trelloLink && (
                            <a href={job.trelloLink} target="_blank" rel="noopener noreferrer" className="p-1.5 hover:bg-blue-100 rounded-lg transition-colors" title="Ver en Trello">
                              <ExternalLink className="w-4 h-4 text-blue-500" />
                            </a>
                          )}
                          <button onClick={() => openEditJob(job)} className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors" title="Editar">
                            <Edit2 className="w-4 h-4 text-gray-500" />
                          </button>
                          {job.status !== 'completed' && (
                            <button onClick={() => setArchiveConfirm({ type: 'job', item: job })} className="p-1.5 hover:bg-green-100 rounded-lg transition-colors" title="Archivar">
                              <Archive className="w-4 h-4 text-green-500" />
                            </button>
                          )}
                          <button onClick={() => deleteJob(job.id)} className="p-1.5 hover:bg-red-100 rounded-lg transition-colors" title="Eliminar">
                            <Trash2 className="w-4 h-4 text-red-400" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {jobs.length === 0 && (
              <div className="text-center py-8 text-gray-400">
                <Briefcase className="w-12 h-12 mx-auto mb-2 opacity-50" />
                <p>No hay trabajos</p>
              </div>
            )}
          </div>
        )}

        {/* Vista Tarjetas */}
        {listViewMode === 'cards' && (
        <div className="grid gap-3 md:gap-4">
          {jobs.map((job) => {
            const jobType = getJobType(job.type);
            const isSameDay = job.startDate === job.endDate;

            return (
              <div key={job.id} className="bg-white border border-gray-500 rounded-xl p-4 hover:border-[#3B82F6] hover:shadow-md transition-all">
                {/* Header: Tipo + Título + Estado */}
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-start gap-3 min-w-0">
                    {/* Icono tipo - estilo minimalista Apple */}
                    <div className="w-10 h-10 rounded-xl bg-gray-50 border border-gray-400 flex items-center justify-center flex-shrink-0">
                      <jobType.icon className="w-5 h-5 text-gray-500" />
                    </div>
                    <div className="min-w-0">
                      <h3 className="font-semibold text-gray-900 truncate">{job.title}</h3>
                      <p className="text-sm text-gray-500">{job.client}</p>
                                )}
                    </div>
                  </div>
                  {/* Estado */}
                  <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium flex-shrink-0 ${
                    job.status === 'pending' ? 'bg-yellow-50 text-yellow-600 border border-yellow-200' :
                    job.status === 'in_progress' ? 'bg-blue-50 text-blue-600 border border-blue-200' :
                    'bg-green-50 text-green-600 border border-green-200'
                  }`}>
                    {job.status === 'pending' ? 'Pendiente' : job.status === 'in_progress' ? 'En progreso' : 'Completado'}
                  </span>
                </div>

                {/* Etiquetas de colores */}
                {job.labels && job.labels.length > 0 && (
                  <div className="flex items-center gap-1.5 mt-3">
                    {job.labels.map((labelId) => {
                      const label = getLabelColor(labelId);
                      return label ? (
                        <span
                          key={labelId}
                          className={`w-6 h-2 rounded-full ${label.bg}`}
                          title={label.label}
                        />
                      ) : null;
                    })}
                  </div>
                )}

                {/* Info: Tipo + Fechas + Trello */}
                <div className="flex flex-wrap items-center gap-3 mt-3 pt-3 border-t border-gray-400">
                  {/* Tipo de trabajo */}
                  <span className="inline-flex items-center gap-1.5 px-2 py-1 bg-gray-50 text-gray-600 rounded-lg text-xs border border-gray-400">
                    <jobType.icon className="w-3 h-3" />
                    {jobType.label}
                  </span>

                  {/* Rango de fechas */}
                  <span className="flex items-center gap-1 text-sm text-gray-500">
                    <Calendar className="w-4 h-4" />
                    {isSameDay ? (
                      new Date(job.startDate).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })
                    ) : (
                      <>
                        {new Date(job.startDate).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}
                        <span className="text-gray-400">→</span>
                        {new Date(job.endDate).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}
                      </>
                    )}
                  </span>

                  {/* Notas */}
                  {job.notes && (
                    <span className="flex items-center gap-1 text-xs text-gray-400" title={job.notes}>
                      <StickyNote className="w-3 h-3" />
                      Notas
                    </span>
                  )}

                  {/* Trello link */}
                  {job.trelloLink && (
                    <a
                      href={job.trelloLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-1 text-xs text-blue-500 hover:underline"
                    >
                      <ExternalLink className="w-3 h-3" />
                      Trello
                    </a>
                  )}

                  {/* Spacer + Actions */}
                  <div className="flex items-center gap-1 ml-auto">
                    <button
                      onClick={() => openEditJob(job)}
                      className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
                      title="Editar"
                    >
                      <Edit2 className="w-4 h-4 text-gray-500" />
                    </button>
                    <button
                      onClick={() => deleteJob(job.id)}
                      className="p-1.5 hover:bg-red-100 rounded-lg transition-colors"
                      title="Eliminar"
                    >
                      <Trash2 className="w-4 h-4 text-red-400" />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}

          {jobs.length === 0 && (
            <div className="text-center py-12 text-gray-400">
              <Briefcase className="w-12 h-12 mx-auto mb-2 opacity-50" />
              <p>No hay trabajos</p>
            </div>
          )}
        </div>
        )}
      </div>
    );
  };

  // Renderizar pestaña de Instalaciones
  const renderInstalaciones = () => {
    return (
      <div className="space-y-4">
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
          <div className="relative flex-1 max-w-md">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Buscar instalaciones..."
              className="w-full pl-9 pr-4 py-2 border border-gray-500 rounded-lg text-sm focus:outline-none focus:border-[#3B82F6]"
            />
          </div>
          <div className="flex items-center gap-2">
            {/* Toggle vista tabla/tarjetas */}
            <div className="flex items-center bg-gray-100 rounded-lg p-0.5">
              <button
                onClick={() => setListViewMode('table')}
                className={`flex items-center gap-1 px-2.5 py-1.5 rounded-md transition-all text-xs font-medium ${listViewMode === 'table' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
                title="Vista tabla"
              >
                <List className="w-3.5 h-3.5" />
                Tabla
              </button>
              <button
                onClick={() => setListViewMode('cards')}
                className={`flex items-center gap-1 px-2.5 py-1.5 rounded-md transition-all text-xs font-medium ${listViewMode === 'cards' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
                title="Vista tarjetas"
              >
                <LayoutGrid className="w-3.5 h-3.5" />
                Tarjetas
              </button>
            </div>
            <button
              onClick={() => setShowNewInstallation(true)}
              className="flex items-center justify-center gap-2 px-4 py-2 bg-[#3B82F6] text-white rounded-lg hover:bg-[#2563EB] transition-colors text-sm font-medium"
            >
              <Plus className="w-4 h-4" />
              Nueva instalación
            </button>
          </div>
        </div>

        
        {/* Vista Tabla */}
        {listViewMode === 'table' && (
          <div className="bg-white border border-gray-500 rounded-lg overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr className="border-b border-gray-300">
                  <th className="text-left px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Instalación</th>
                  <th className="text-left px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Localidad</th>
                  <th className="text-left px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Contrato</th>
                  <th className="text-left px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                  <th className="text-left px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                  <th className="text-left px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Depts</th>
                  <th className="text-right px-4 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-28">Acciones</th>
                </tr>
                <tr className="border-b border-gray-400 bg-gray-100">
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"></th>
                  <th className="px-1 py-1"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {installations.map((inst) => (
                  <tr key={inst.id} className={`hover:bg-gray-50 transition-colors ${inst.status === 'completed' ? 'bg-green-50/50' : ''}`}>
                    <td className="px-4 py-3">
                      <span className="font-medium text-gray-900">{inst.nombre}</span>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">{inst.localidad}, {inst.provincia}</td>
                    <td className="px-4 py-3 text-sm text-gray-500">{inst.idContrato}</td>
                    <td className="px-4 py-3 text-sm text-gray-500">
                      {inst.fechaPrevistaInstalacion && new Date(inst.fechaPrevistaInstalacion).toLocaleDateString('es-ES')}
                    </td>
                    <td className="px-4 py-3">
                      <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${
                        inst.status === 'pending' ? 'bg-yellow-50 text-yellow-600 border border-yellow-200' :
                        inst.status === 'in_progress' ? 'bg-blue-50 text-blue-600 border border-blue-200' :
                        'bg-green-50 text-green-600 border border-green-200'
                      }`}>
                        {inst.status === 'pending' ? 'Pendiente' : inst.status === 'in_progress' ? 'En curso' : 'Completada'}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex flex-wrap gap-1">
                        {inst.deptEntradas && <span className="px-1.5 py-0.5 bg-blue-50 text-blue-600 text-[10px] rounded">E</span>}
                        {inst.deptDiseno && <span className="px-1.5 py-0.5 bg-purple-50 text-purple-600 text-[10px] rounded">D</span>}
                        {inst.deptSAT && <span className="px-1.5 py-0.5 bg-orange-50 text-orange-600 text-[10px] rounded">S</span>}
                        {inst.deptComercial && <span className="px-1.5 py-0.5 bg-green-50 text-green-600 text-[10px] rounded">C</span>}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <div className="flex items-center justify-end gap-1">
                        {inst.status !== 'completed' && (
                          <button onClick={() => setArchiveConfirm({ type: 'installation', item: inst })} className="p-1.5 hover:bg-green-100 rounded-lg transition-colors" title="Archivar">
                            <Archive className="w-4 h-4 text-green-500" />
                          </button>
                        )}
                        <button onClick={() => deleteInstallation(inst.id)} className="p-1.5 hover:bg-red-100 rounded-lg transition-colors" title="Eliminar">
                          <Trash2 className="w-4 h-4 text-red-400" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {installations.length === 0 && (
              <div className="text-center py-8 text-gray-400">
                <Wrench className="w-12 h-12 mx-auto mb-2 opacity-50" />
                <p>No hay instalaciones</p>
              </div>
            )}
          </div>
        )}

        {/* Vista Tarjetas */}
        {listViewMode === 'cards' && (
        <div className="grid gap-3 md:gap-4">
          {installations.map((inst) => (
            <div key={inst.id} className="bg-white border border-gray-500 rounded-xl p-4 hover:border-[#3B82F6] hover:shadow-md transition-all">
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-start gap-3 min-w-0">
                  <div className="w-10 h-10 rounded-xl bg-orange-50 border border-orange-100 flex items-center justify-center flex-shrink-0">
                    <Wrench className="w-5 h-5 text-orange-500" />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-semibold text-gray-900 truncate">{inst.nombre}</h3>
                    <p className="text-sm text-gray-500">{inst.localidad}, {inst.provincia}</p>
                    <p className="text-xs text-gray-400">Contrato: {inst.idContrato}</p>
                  </div>
                </div>
                <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium flex-shrink-0 ${
                  inst.status === 'pending' ? 'bg-yellow-50 text-yellow-600 border border-yellow-200' :
                  inst.status === 'in_progress' ? 'bg-blue-50 text-blue-600 border border-blue-200' :
                  'bg-green-50 text-green-600 border border-green-200'
                }`}>
                  {inst.status === 'pending' ? 'Pendiente' : inst.status === 'in_progress' ? 'En curso' : 'Completada'}
                </span>
              </div>
              <div className="flex flex-wrap items-center gap-2 mt-3 pt-3 border-t border-gray-400">
                {inst.deptEntradas && <span className="px-2 py-0.5 bg-blue-50 text-blue-600 text-xs rounded">Entradas</span>}
                {inst.deptDiseno && <span className="px-2 py-0.5 bg-purple-50 text-purple-600 text-xs rounded">Diseño</span>}
                {inst.deptSAT && <span className="px-2 py-0.5 bg-orange-50 text-orange-600 text-xs rounded">SAT</span>}
                {inst.deptComercial && <span className="px-2 py-0.5 bg-green-50 text-green-600 text-xs rounded">Comercial</span>}
                <span className="ml-auto text-xs text-gray-400">
                  {inst.fechaPrevistaInstalacion && `Instalación: ${new Date(inst.fechaPrevistaInstalacion).toLocaleDateString('es-ES')}`}
                </span>
              </div>
            </div>
          ))}

          {installations.length === 0 && (
            <div className="text-center py-12 text-gray-400">
              <Wrench className="w-12 h-12 mx-auto mb-2 opacity-50" />
              <p>No hay instalaciones</p>
            </div>
          )}
        </div>
        )}
      </div>
    );
  };

  // Obtener tareas del día seleccionado
  const getTasksForDate = (date) => {
    const checkDate = new Date(date);
    checkDate.setHours(0,0,0,0);
    const today = new Date();
    today.setHours(0,0,0,0);
    
    return tasks.filter(task => {
      if (task.completed) return false;
      if (!task.dueDate) return false;
      
      const taskDate = new Date(task.dueDate);
      taskDate.setHours(0,0,0,0);
      
      // Tarea del mismo dia
      if (taskDate.toDateString() === checkDate.toDateString()) return true;
      
      // Tarea atrasada - mostrar en dias posteriores hasta hoy
      if (taskDate < checkDate && checkDate <= today) return true;
      
      return false;
    });
  };

  // Obtener festivo del día
  const getHolidayForDate = (date) => {
    const dateStr = date.toISOString().split('T')[0];
    return HOLIDAYS_2026.find(h => h.date === dateStr);
  };

  // Generar días del calendario
  const generateCalendarDays = () => {
    const year = calendarMonth.getFullYear();
    const month = calendarMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startPadding = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1; // Lunes = 0
    const days = [];

    // Días del mes anterior
    for (let i = startPadding - 1; i >= 0; i--) {
      const d = new Date(year, month, -i);
      days.push({ date: d, currentMonth: false });
    }

    // Días del mes actual
    for (let i = 1; i <= lastDay.getDate(); i++) {
      days.push({ date: new Date(year, month, i), currentMonth: true });
    }

    // Completar última semana
    const remaining = 42 - days.length;
    for (let i = 1; i <= remaining; i++) {
      days.push({ date: new Date(year, month + 1, i), currentMonth: false });
    }

    return days;
  };

  const formatDate = (date) => {
    const dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    return `${dias[date.getDay()]}, ${date.getDate()} de ${meses[date.getMonth()]}`;
  };

  // Generar días de la semana actual
  const getWeekDays = () => {
    const start = new Date(selectedDate);
    const day = start.getDay();
    const diff = start.getDate() - day + (day === 0 ? -6 : 1); // Lunes como inicio
    start.setDate(diff);

    const days = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      days.push(d);
    }
    return days;
  };

  // Horas del día (7:00 - 22:00)
  const hours = Array.from({ length: 16 }, (_, i) => i + 7);

  // Navegar anterior/siguiente según vista
  const navigatePrev = () => {
    if (calendarView === 'day') {
      setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate() - 1));
    } else if (calendarView === 'week') {
      setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate() - 7));
    } else {
      setCalendarMonth(new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() - 1));
    }
  };

  const navigateNext = () => {
    if (calendarView === 'day') {
      setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate() + 1));
    } else if (calendarView === 'week') {
      setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate() + 7));
    } else {
      setCalendarMonth(new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1));
    }
  };

  const goToToday = () => {
    setSelectedDate(new Date());
    setCalendarMonth(new Date());
  };

  // Vista de DÍA
  const renderDayView = () => (
    <div className="flex-1 bg-white rounded-lg border border-gray-500 overflow-hidden">
      <div className="h-full overflow-y-auto">
        {hours.map((hour) => {
          const hourTasks = tasks.filter(task => {
            if (!task.dueDate) return false;
            const taskDate = new Date(task.dueDate);
            return taskDate.toDateString() === selectedDate.toDateString() && taskDate.getHours() === hour;
          });

          return (
            <div key={hour} className="flex border-b border-gray-400 min-h-[60px]">
              <div className="w-16 py-2 px-2 text-xs text-gray-500 text-right border-r border-gray-400 flex-shrink-0">
                {hour.toString().padStart(2, '0')}:00
              </div>
              <div className="flex-1 p-1 hover:bg-gray-50 cursor-pointer" onClick={() => {
                setNewTaskForm(prev => ({...prev, dueDate: selectedDate.toISOString().split('T')[0], dueTime: `${hour.toString().padStart(2, '0')}:00`}));
                setShowNewTask(true);
              }}>
                {hourTasks.map(task => {
                  const priority = PRIORITIES[task.priority] || PRIORITIES.medium;
                  return (
                    <div key={task.id} className={`px-2 py-1 rounded text-sm mb-1 ${priority.bg} ${priority.color} cursor-pointer`} onClick={(e) => { e.stopPropagation(); openEditTask(task); }}>
                      {task.title}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  // Vista de SEMANA
  const renderWeekView = () => {
    const weekDays = getWeekDays();
    const dayNames = ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'];

    return (
      <div className="flex-1 bg-white rounded-lg border border-gray-500 overflow-hidden flex flex-col">
        {/* Header con días */}
        <div className="flex border-b border-gray-500 bg-gray-50">
          <div className="w-16 flex-shrink-0 border-r border-gray-500"></div>
          {weekDays.map((day, i) => {
            const isToday = day.toDateString() === new Date().toDateString();
            const holiday = getHolidayForDate(day);
            return (
              <div key={i} className={`flex-1 py-2 text-center border-r border-gray-400 last:border-r-0 ${isToday ? 'bg-blue-50' : ''} ${holiday ? 'bg-blue-50/60' : ''}`}>
                <div className="text-xs text-gray-500">{dayNames[i]}</div>
                <div className={`text-lg font-semibold ${isToday ? 'text-[#3B82F6]' : holiday ? 'text-blue-700' : 'text-gray-900'}`}>
                  {day.getDate()}
                </div>
                {holiday && (
                  <div className="relative group/hol">
                      <div className="bg-blue-600 text-white text-base font-bold px-3 py-1.5 rounded mx-1 shadow-lg cursor-pointer">{holiday.name}</div>
                      <div className="absolute z-[100] bottom-full left-1/2 -translate-x-1/2 mb-2 px-4 py-3 bg-blue-700 text-white text-xl font-bold rounded-xl shadow-2xl opacity-0 group-hover/hol:opacity-100 transition-opacity whitespace-nowrap pointer-events-none border-2 border-blue-400">
                        {holiday.name}
                      </div>
                    </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Horas */}
        <div className="flex-1 overflow-y-auto">
          {hours.map((hour) => (
            <div key={hour} className="flex border-b border-gray-400 min-h-[50px]">
              <div className="w-16 py-1 px-2 text-xs text-gray-500 text-right border-r border-gray-400 flex-shrink-0">
                {hour.toString().padStart(2, '0')}:00
              </div>
              {weekDays.map((day, dayIndex) => {
                const dayTasks = tasks.filter(task => {
                  if (!task.dueDate) return false;
                  const taskDate = new Date(task.dueDate);
                  return taskDate.toDateString() === day.toDateString() && taskDate.getHours() === hour;
                });

                return (
                  <div key={dayIndex} className="flex-1 p-0.5 border-r border-gray-400 last:border-r-0 hover:bg-gray-50 cursor-pointer" onClick={() => {
                    setSelectedDate(day);
                    setNewTaskForm(prev => ({...prev, dueDate: day.toISOString().split('T')[0], dueTime: `${hour.toString().padStart(2, '0')}:00`}));
                    setShowNewTask(true);
                  }}>
                    {dayTasks.map(task => {
                      const priority = PRIORITIES[task.priority] || PRIORITIES.medium;
                      return (
                        <div key={task.id} className={`px-1 py-0.5 rounded text-xs truncate ${priority.bg} ${priority.color}`} title={task.title} onClick={(e) => { e.stopPropagation(); openEditTask(task); }}>
                          {task.title}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Vista de MES
  const renderMonthView = () => {
    // Tamaños según viewSize
    const sizes = {
      compact: { header: 'text-xs py-1', day: 'text-xs', dayCircle: 'w-5 h-5 text-xs', task: 'text-[10px] px-0.5 py-0', maxTasks: 1, padding: 'p-0.5' },
      normal: { header: 'text-sm py-2', day: 'text-sm', dayCircle: 'w-6 h-6', task: 'text-xs px-1 py-0.5', maxTasks: 2, padding: 'p-1' },
      large: { header: 'text-base py-3', day: 'text-lg', dayCircle: 'w-8 h-8 text-base', task: 'text-sm px-2 py-1', maxTasks: 4, padding: 'p-2' }
    };
    const s = sizes[viewSize];

    return (
      <div className="flex-1 bg-white rounded-lg border border-gray-500 overflow-hidden flex flex-col">
        {/* Header días semana */}
        <div className="grid grid-cols-7 border-b border-gray-500 bg-gray-50">
          {['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'].map((d, i) => (
            <div key={i} className={`${s.header} text-center font-medium text-gray-600 border-r border-gray-400 last:border-r-0`}>
              {viewSize === 'compact' ? d.slice(0, 3) : d}
            </div>
          ))}
        </div>

        {/* Días del mes */}
        <div className="flex-1 grid grid-cols-7 auto-rows-fr">
          {generateCalendarDays().map((day, i) => {
            const isToday = day.date.toDateString() === new Date().toDateString();
            const isSelected = day.date.toDateString() === selectedDate.toDateString();
            const dayTasks = getTasksForDate(day.date);
            const holiday = getHolidayForDate(day.date);

            return (
              <div
                key={i}
                onClick={() => {
                  setSelectedDate(day.date);
                  const dateStr = day.date.toISOString().split('T')[0];
                  const dayTasks = tasks.filter(t => t.dueDate && t.dueDate.split('T')[0] === dateStr && t.status !== 'completed');
                  const dayJobs = jobs.filter(j => {
                    if (!j.startDate || !j.endDate) return false;
                    const s = new Date(j.startDate); s.setHours(0,0,0,0);
                    const e = new Date(j.endDate); e.setHours(23,59,59,999);
                    const check = new Date(day.date); check.setHours(12,0,0,0);
                    return check >= s && check <= e && j.status !== 'completed';
                  });
                  const dayInst = installations.filter(i => ((i.fechaPrevistaInstalacion && i.fechaPrevistaInstalacion.split('T')[0] === dateStr) || (i.installDate && i.installDate.split('T')[0] === dateStr)) && i.status !== 'completed');
                  const types = (dayTasks.length > 0 ? 1 : 0) + (dayJobs.length > 0 ? 1 : 0) + (dayInst.length > 0 ? 1 : 0);
                  const getPriority = (p) => p === 'high' ? 'alta' : p === 'medium' ? 'media' : p === 'low' ? 'baja' : p || 'baja';
                  // Marcar rango de dias si es trabajo multi-dia
                  if (dayJobs.length === 1 && dayJobs[0].startDate && dayJobs[0].endDate) {
                    const s = new Date(dayJobs[0].startDate); s.setHours(0,0,0,0);
                    const e = new Date(dayJobs[0].endDate); e.setHours(23,59,59,999);
                    setSelectedDateRange({start: s, end: e});
                  } else {
                    setSelectedDateRange(null);
                  }
                  if (types === 0) return;
                  if (types > 1) {
                    setSelectedPriority('todas');
                    setUrgentType('tareas');
                  } else if (dayTasks.length > 0) {
                    setUrgentType('tareas');
                    if (dayTasks.length === 1) setSelectedPriority(getPriority(dayTasks[0].priority));
                    else setSelectedPriority('todas');
                  } else if (dayJobs.length > 0) {
                    setUrgentType('trabajos');
                    if (dayJobs.length === 1) setSelectedPriority(getPriority(dayJobs[0].priority));
                    else setSelectedPriority('todas');
                  } else if (dayInst.length > 0) {
                    setUrgentType('instalaciones');
                    if (dayInst.length === 1) setSelectedPriority(getPriority(dayInst[0].priority));
                    else setSelectedPriority('todas');
                  }
                }}
                className={`
                  border-r border-b border-gray-400 ${s.padding} cursor-pointer hover:bg-gray-50 transition-colors
                  ${!day.currentMonth ? 'bg-gray-50' : ''}
                  ${isSelected ? 'ring-2 ring-inset ring-[#3B82F6]' : ''}
                  ${holiday && day.currentMonth ? 'bg-blue-50/60' : ''}
                `}
              >
                <div className={`
                  ${s.day} font-medium mb-1
                  ${!day.currentMonth ? 'text-gray-400' : 'text-gray-900'}
                  ${isToday ? `${s.dayCircle} bg-[#3B82F6] text-white rounded-full flex items-center justify-center` : ''}
                  ${holiday && day.currentMonth && !isToday ? 'text-blue-700' : ''}
                `}>
                  {day.date.getDate()}
                </div>
                {holiday && day.currentMonth && (
                  <div className="relative group/hol2">
                      <div className="bg-blue-600 text-white text-sm font-bold px-2 py-1 rounded mb-1 shadow-lg cursor-pointer">{holiday.name}</div>
                      <div className="absolute z-[100] bottom-full left-1/2 -translate-x-1/2 mb-2 px-4 py-3 bg-blue-700 text-white text-xl font-bold rounded-xl shadow-2xl opacity-0 group-hover/hol2:opacity-100 transition-opacity whitespace-nowrap pointer-events-none border-2 border-blue-400">
                        {holiday.name}
                      </div>
                    </div>
                )}
                {dayTasks.slice(0, s.maxTasks).map(task => {
                  const priority = PRIORITIES[task.priority] || PRIORITIES.medium;
                  return (
                    <div key={task.id} className={`${s.task} rounded truncate mb-0.5 ${priority.bg} ${priority.color}`} onClick={(e) => { e.stopPropagation(); openEditTask(task); }}>
                      {task.title}
                    </div>
                  );
                })}
                {dayTasks.length > s.maxTasks && (
                  <div className={`${s.task} text-gray-500`}>+{dayTasks.length - s.maxTasks} más</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderCalendario = () => (
    <div className="h-full flex flex-col gap-4">
      {/* Toolbar estilo Google Calendar */}
      <div className="flex items-center justify-between bg-white rounded-lg border border-gray-500 p-3">
        <div className="flex items-center gap-2">
          <button
            onClick={goToToday}
            className="px-3 py-1.5 text-sm font-medium text-gray-700 border border-gray-500 rounded-lg hover:bg-gray-50"
          >
            Hoy
          </button>
          <div className="flex items-center">
            <button onClick={navigatePrev} className="p-1.5 hover:bg-gray-100 rounded-lg">
              <ChevronLeft className="w-5 h-5 text-gray-600" />
            </button>
            <button onClick={navigateNext} className="p-1.5 hover:bg-gray-100 rounded-lg">
              <ChevronRight className="w-5 h-5 text-gray-600" />
            </button>
          </div>
          <h2 className="text-lg font-semibold text-gray-900 ml-2">
            {calendarView === 'day' ? formatDate(selectedDate) :
             calendarView === 'week' ? `Semana del ${getWeekDays()[0].getDate()} al ${getWeekDays()[6].getDate()} de ${selectedDate.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' })}` :
             calendarMonth.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' })}
          </h2>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => {
              setNewTaskForm(prev => ({...prev, dueDate: selectedDate.toISOString().split('T')[0]}));
              setShowNewTask(true);
            }}
            className="flex items-center gap-1 px-3 py-1.5 bg-[#3B82F6] text-white rounded-lg hover:bg-[#2563EB] text-sm font-medium"
          >
            <Plus className="w-4 h-4" />
            Crear
          </button>
          <div className="flex items-center bg-gray-100 rounded-lg p-0.5">
            <button
              onClick={() => setCalendarView('day')}
              className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${calendarView === 'day' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`}
            >
              Día
            </button>
            <button
              onClick={() => setCalendarView('week')}
              className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${calendarView === 'week' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`}
            >
              Semana
            </button>
            <button
              onClick={() => setCalendarView('month')}
              className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${calendarView === 'month' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`}
            >
              Mes
            </button>
          </div>
          {/* Tamaño de vista */}
          <div className="flex items-center bg-gray-100 rounded-lg p-0.5 ml-2">
            <button
              onClick={() => setViewSize('compact')}
              className={`p-1.5 rounded-md transition-colors ${viewSize === 'compact' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-900'}`}
              title="Vista compacta"
            >
              <List className="w-4 h-4" />
            </button>
            <button
              onClick={() => setViewSize('normal')}
              className={`p-1.5 rounded-md transition-colors ${viewSize === 'normal' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-900'}`}
              title="Vista normal"
            >
              <Grid3X3 className="w-4 h-4" />
            </button>
            <button
              onClick={() => setViewSize('large')}
              className={`p-1.5 rounded-md transition-colors ${viewSize === 'large' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-900'}`}
              title="Vista grande"
            >
              <LayoutGrid className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>

      {/* Vista del calendario */}
      {calendarView === 'day' && renderDayView()}
      {calendarView === 'week' && renderWeekView()}
      {calendarView === 'month' && renderMonthView()}
    </div>
  );

  // Obtener trabajos del día seleccionado
  const getJobsForDate = (date) => {
    return jobs.filter(job => {
      const start = new Date(job.startDate);
      const end = new Date(job.endDate);
      start.setHours(0,0,0,0);
      end.setHours(23,59,59,999);
      const checkDate = new Date(date);
      checkDate.setHours(12,0,0,0);
      return checkDate >= start && checkDate <= end;
    });
  };
  
  // Verificar si un dia esta en el rango seleccionado
  const isInSelectedRange = (date) => {
    if (!selectedDateRange) return false;
    const checkDate = new Date(date);
    checkDate.setHours(12,0,0,0);
    return checkDate >= selectedDateRange.start && checkDate <= selectedDateRange.end;
  };

  // Obtener instalaciones del día
  const getInstallationsForDate = (date) => {
    const dateStr = date.toISOString().split('T')[0];
    return installations.filter(inst => {
      if (inst.fechaPrevistaInstalacion) {
        return inst.fechaPrevistaInstalacion.split('T')[0] === dateStr;
      }
      return false;
    });
  };

  const selectedDayTasks = getTasksForDate(selectedDate);
  const selectedDayJobs = getJobsForDate(selectedDate);
  const selectedDayHoliday = getHolidayForDate(selectedDate);

  // Obtener tareas urgentes - SOLO prioridad ALTA
  const getUrgentTasks = () => {
    return tasks.filter(task => {
      if (task.status === 'completed' || task.completed) return false;
      // Solo mostrar tareas con prioridad ALTA
      return task.priority === 'alta' || task.priority === 'high';
    }).slice(0, 5);
  };

  const urgentTasks = getUrgentTasks();

  // Renderizar Historial/Logs de completados
  const renderLogs = () => {
    const completedTasks = tasks.filter(t => t.status === 'completed');
    const completedJobs = jobs.filter(j => j.status === 'completed');
    const completedInstallations = installations.filter(i => i.status === 'completed');
    const completedNotes = notes.filter(n => n.is_completed);

    const allCompleted = [
      ...completedTasks.map(t => ({ ...t, _type: 'tarea', _completedAt: t.completed_at })),
      ...completedJobs.map(j => ({ ...j, _type: 'trabajo', _completedAt: j.completed_at })),
      ...completedInstallations.map(i => ({ ...i, _type: 'instalacion', _completedAt: i.completed_at })),
      ...completedNotes.map(n => ({ ...n, _type: 'nota', _completedAt: n.completed_at, title: n.text?.slice(0, 50) + (n.text?.length > 50 ? '...' : '') }))
    ].sort((a, b) => new Date(b._completedAt || 0) - new Date(a._completedAt || 0));

    // Aplicar filtros por columna
    const filteredCompleted = allCompleted.filter(item => {
      const tipoLabel = item._type === 'tarea' ? 'Tarea' : item._type === 'trabajo' ? 'Trabajo' : item._type === 'nota' ? 'Nota' : 'Instalación';
      const tituloStr = (item.title || item.nombre || '').toLowerCase();
      const clienteStr = (item.cliente || item.client || '').toLowerCase();
      const tiempoStr = item.time_spent ? `${item.time_spent} min` : '';
      const completadoStr = item._completedAt ? new Date(item._completedAt).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '';

      const matchesTipo = !logFilters.tipo || tipoLabel.toLowerCase().includes(logFilters.tipo.toLowerCase());
      const matchesTitulo = !logFilters.titulo || tituloStr.includes(logFilters.titulo.toLowerCase());
      const matchesCliente = !logFilters.cliente || clienteStr.includes(logFilters.cliente.toLowerCase());
      const matchesTiempo = !logFilters.tiempo || tiempoStr.includes(logFilters.tiempo);
      const matchesCompletado = !logFilters.completado || completadoStr.toLowerCase().includes(logFilters.completado.toLowerCase());

      return matchesTipo && matchesTitulo && matchesCliente && matchesTiempo && matchesCompletado;
    });

    return (
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
            <Archive className="w-5 h-5 text-green-600" />
            Historial de completados
          </h2>
          <span className="text-sm text-gray-500">
            {allCompleted.length} elemento{allCompleted.length !== 1 ? 's' : ''}
          </span>
        </div>

        {allCompleted.length === 0 ? (
          <div className="text-center py-12 text-gray-400">
            <Archive className="w-12 h-12 mx-auto mb-2 opacity-50" />
            <p>No hay elementos completados</p>
          </div>
        ) : (
          <div className="bg-white border border-gray-500 rounded-lg overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr className="border-b border-gray-300">
                  <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-28">Tipo</th>
                  <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">Título</th>
                  <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-32">Cliente</th>
                  <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-24">Tiempo</th>
                  <th className="text-left px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-32">Completado</th>
                  <th className="text-right px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider w-28">Acciones</th>
                </tr>
                <tr className="border-b border-gray-400 bg-gray-100">
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={logFilters.tipo} onChange={(e) => setLogFilters({...logFilters, tipo: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={logFilters.titulo} onChange={(e) => setLogFilters({...logFilters, titulo: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={logFilters.cliente} onChange={(e) => setLogFilters({...logFilters, cliente: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={logFilters.tiempo} onChange={(e) => setLogFilters({...logFilters, tiempo: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"><input type="text" placeholder="Buscar..." value={logFilters.completado} onChange={(e) => setLogFilters({...logFilters, completado: e.target.value})} className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400" /></th>
                  <th className="px-1 py-1"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filteredCompleted.map((item) => (
                  <tr key={`${item._type}-${item.id}`} className="hover:bg-gray-50 transition-colors bg-green-50/30">
                    <td className="px-4 py-3">
                      <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-lg text-xs font-medium ${
                        item._type === 'tarea' ? 'bg-amber-50 text-amber-600 border border-amber-200' :
                        item._type === 'trabajo' ? 'bg-orange-50 text-orange-600 border border-orange-200' :
                        item._type === 'nota' ? 'bg-yellow-50 text-yellow-600 border border-yellow-200' :
                        'bg-purple-50 text-purple-600 border border-purple-200'
                      }`}>
                        {item._type === 'tarea' ? <CheckSquare className="w-3 h-3" /> :
                         item._type === 'trabajo' ? <Briefcase className="w-3 h-3" /> :
                         item._type === 'nota' ? <StickyNote className="w-3 h-3" /> :
                         <Wrench className="w-3 h-3" />}
                        {item._type === 'tarea' ? 'Tarea' : item._type === 'trabajo' ? 'Trabajo' : item._type === 'nota' ? 'Nota' : 'Instalación'}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <span className="font-medium text-gray-900">{item.title || item.nombre}</span>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {item.cliente || item.client || '-'}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-500">
                      {item.time_spent ? (
                        <span className="flex items-center gap-1">
                          <Clock className="w-3 h-3" />
                          {item.time_spent} min
                        </span>
                      ) : '-'}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-500">
                      {item._completedAt ? new Date(item._completedAt).toLocaleDateString('es-ES', {
                        day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit'
                      }) : '-'}
                    </td>
                    <td className="px-4 py-3 text-right">
                      <div className="flex items-center justify-end gap-1">
                        <button
                          onClick={() => {
                            if (item._type === 'tarea') {
                              updateTaskStatus(item.id, 'pending');
                            } else if (item._type === 'trabajo') {
                              updateJobStatus(item.id, 'pending');
                            } else if (item._type === 'nota') {
                              toggleNoteCompleted(item.id);
                            } else {
                              updateInstallationStatus(item.id, 'pending');
                            }
                          }}
                          className="inline-flex items-center gap-1 px-2 py-1.5 text-xs font-medium text-orange-600 bg-orange-50 hover:bg-orange-100 rounded-lg transition-colors border border-orange-200"
                          title="Reabrir"
                        >
                          <RotateCcw className="w-3 h-3" />
                          Reabrir
                        </button>
                        <button
                          onClick={() => {
                            if (item._type === 'tarea') {
                              deleteTask(item.id);
                            } else if (item._type === 'trabajo') {
                              deleteJob(item.id);
                            } else if (item._type === 'nota') {
                              deleteNote(item.id);
                            } else {
                              deleteInstallation(item.id);
                            }
                          }}
                          className="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                          title="Eliminar"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="h-full flex flex-col bg-gradient-to-br from-slate-50 to-gray-100">
      {/* Panel superior: NOTAS | URGENTE | CALENDARIO */}
      <div className="flex flex-col">
        {/* Barra unificada con títulos y controles - degradado blanco a gris */}
        <div className="px-4 py-2 flex items-center justify-between border-b border-gray-300" style={{ background: 'linear-gradient(to bottom, #ffffff 0%, #f3f4f6 100%)' }}>
          {/* Títulos NOTAS | TAREAS | CALENDARIO */}
          <div className="flex items-center flex-1">
            <div style={{ width: `${notesWidth}%` }} className="text-center">
              <span className="text-xs font-semibold text-gray-500 uppercase tracking-widest">NOTAS</span>
            </div>
            <div style={{ width: `${urgentWidth}%` }} className="text-center">
              <span className="text-xs font-semibold text-gray-500 uppercase tracking-widest">TAREAS</span>
            </div>
            <div style={{ width: `${100 - notesWidth - urgentWidth}%` }} className="text-center">
              <span className="text-xs font-semibold text-gray-500 uppercase tracking-widest">CALENDARIO</span>
            </div>
          </div>
          {/* Iconos a la derecha */}
          <div className="flex items-center gap-1">
            <button
              onClick={(e) => { e.stopPropagation(); saveLayout(); }}
              className={`p-2 rounded-lg transition-all ${
                layoutSaved ? 'bg-emerald-500 text-white' : 'text-gray-500 hover:bg-gray-200 hover:text-gray-700'
              }`}
              title="Guardar disposición"
            >
              <Save className="w-5 h-5" />
            </button>
            <button
              onClick={resetLayout}
              className="p-2 rounded-lg text-gray-500 hover:bg-gray-200 hover:text-gray-700 transition-all"
              title="Restaurar disposición"
            >
              <RotateCcw className="w-5 h-5" />
            </button>
            <button
              onClick={() => setHeaderCollapsed(!headerCollapsed)}
              className="p-2 rounded-lg text-gray-500 hover:bg-gray-200 hover:text-gray-700 transition-all"
              title={headerCollapsed ? 'Mostrar panel' : 'Ocultar panel'}
            >
              {headerCollapsed ? <ChevronDown className="w-5 h-5" /> : <ChevronUp className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {/* Contenido colapsable - tres columnas redimensionables */}
        {!headerCollapsed && (
          <div className="flex flex-col">
            <div
              className="flex resize-container gap-2 px-4 py-3 bg-white"
              style={{ height: `${headerHeight}px` }}
            >
              {/* COLUMNA IZQUIERDA: NOTAS - AMARILLO */}
              <div
                className="flex flex-col overflow-hidden relative rounded-2xl"
                style={{
                  width: `${notesWidth}%`,
                  background: 'linear-gradient(145deg, #FEF9C3 0%, #FEF08A 100%)',
                  border: '1px solid #EAB308'
                }}
              >
                {/* Handle resize */}
                <div
                  onMouseDown={handleLeftResize}
                  className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-yellow-600/10 z-10 select-none"
                  style={{ touchAction: 'none' }}
                />
                {/* Header */}
                <div className="px-4 py-3 border-b border-yellow-400/30 bg-yellow-200/30">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-xl bg-yellow-400 flex items-center justify-center shadow-sm">
                        <StickyNote className="w-4 h-4 text-white" />
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-yellow-900">Notas</h3>
                        <p className="text-[10px] text-yellow-700">
                          {selectedDate.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'short' })}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-1">
                      {/* Icono historial de enviadas */}
                      <button
                        onClick={() => setShowSentNotes(true)}
                        className="w-7 h-7 rounded-lg bg-blue-500 hover:bg-blue-600 text-white flex items-center justify-center transition-colors shadow-sm relative"
                        title="Notas enviadas"
                      >
                        <ExternalLink className="w-3.5 h-3.5" />
                        {getSentNotes().filter(n => !n.is_read).length > 0 && (
                          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center">
                            {getSentNotes().filter(n => !n.is_read).length}
                          </span>
                        )}
                      </button>
                      {/* Botón nueva nota */}
                      <button
                        onClick={() => setShowNewNote(true)}
                        className="w-7 h-7 rounded-lg bg-yellow-500 hover:bg-yellow-600 text-white flex items-center justify-center transition-colors shadow-sm"
                      >
                        <Plus className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Content - con padding extra para alinear con tareas que tiene tabs */}
                <div className="flex-1 overflow-y-auto p-2 space-y-1.5 scrollbar-thin scrollbar-thumb-yellow-300 scrollbar-track-transparent">
                  {showNewNote && (
                    <div className="bg-white/50 rounded-lg p-2 shadow-sm border border-yellow-300/50">
                      {/* Selector: Para mí / Para compañero */}
                      <div className="flex gap-2 mb-2">
                        <button
                          onClick={() => { setNoteForSelf(true); setNoteAssignee(''); }}
                          className={`flex-1 px-2 py-1 text-xs rounded-md transition-colors ${
                            noteForSelf ? 'bg-yellow-500 text-white' : 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200'
                          }`}
                        >
                          Para mí
                        </button>
                        <button
                          onClick={() => setNoteForSelf(false)}
                          className={`flex-1 px-2 py-1 text-xs rounded-md transition-colors ${
                            !noteForSelf ? 'bg-blue-500 text-white' : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                          }`}
                        >
                          Para compañero
                        </button>
                      </div>
                      {/* Dropdown de compañeros */}
                      {!noteForSelf && (
                        <select
                          value={noteAssignee}
                          onChange={(e) => setNoteAssignee(e.target.value)}
                          className="w-full px-2 py-1.5 text-xs bg-white/80 rounded-md border border-blue-300/50 focus:outline-none focus:ring-1 focus:ring-blue-400 mb-2"
                        >
                          <option value="">Selecciona compañero...</option>
                          {users.filter(u => u.id !== user?.id).map(u => (
                            <option key={u.id} value={u.id}>{u.name || u.email}</option>
                          ))}
                        </select>
                      )}
                      <textarea
                        value={newNoteText}
                        onChange={(e) => setNewNoteText(e.target.value)}
                        placeholder={noteForSelf ? "Escribe tu nota..." : "Escribe la nota para tu compañero..."}
                        className={`w-full px-2 py-1.5 text-xs bg-white/80 rounded-md border focus:outline-none focus:ring-1 placeholder-gray-400 resize-none ${
                          noteForSelf ? 'border-yellow-300/50 focus:ring-yellow-400' : 'border-blue-300/50 focus:ring-blue-400'
                        }`}
                        rows={2}
                        autoFocus
                      />
                      <div className="flex justify-end gap-1.5 mt-1.5">
                        <button onClick={() => { setShowNewNote(false); setNewNoteText(''); setNoteForSelf(true); setNoteAssignee(''); }} className="px-2 py-1 text-xs text-gray-600 hover:bg-gray-100 rounded-md transition-colors">
                          Cancelar
                        </button>
                        <button
                          onClick={addNote}
                          disabled={!noteForSelf && !noteAssignee}
                          className={`px-2 py-1 text-xs text-white rounded-md transition-colors font-medium disabled:opacity-50 ${
                            noteForSelf ? 'bg-yellow-500 hover:bg-yellow-600' : 'bg-blue-500 hover:bg-blue-600'
                          }`}
                        >
                          {noteForSelf ? 'Guardar' : 'Enviar'}
                        </button>
                      </div>
                    </div>
                  )}
                  {getNotesForSelectedDate().filter(n => !n.is_completed).map(note => {
                    const isFromOther = note.assigned_to === user?.id && note.created_by !== user?.id;
                    const isUnread = isFromOther && !note.is_read;
                    return (
                      <div
                        key={note.id}
                        onClick={() => isUnread && markNoteAsRead(note.id)}
                        className={`group rounded-xl p-3 transition-all shadow-sm hover:shadow border cursor-pointer ${
                          isFromOther
                            ? 'bg-blue-50/70 hover:bg-blue-50 border-blue-400/30'
                            : 'bg-white/70 hover:bg-white border-yellow-400/30'
                        }`}
                      >
                        {/* Badge NEW + Remitente */}
                        {isFromOther && (
                          <div className="flex items-center gap-2 mb-1.5">
                            {isUnread && (
                              <span className="px-1.5 py-0.5 text-[10px] font-bold bg-red-500 text-white rounded">NEW</span>
                            )}
                            <span className="text-[10px] text-blue-600 font-medium">
                              De: {note.sender?.full_name || 'Compañero'}
                            </span>
                          </div>
                        )}
                        <p className="text-sm text-gray-800 leading-relaxed">{note.text}</p>
                        <div className="flex justify-end gap-1 mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                          {!isFromOther && (
                            <button
                              onClick={(e) => { e.stopPropagation(); setEditingNote(note); setShowNewNote(true); }}
                              className="p-1.5 text-yellow-600 hover:text-yellow-800 hover:bg-yellow-100 rounded-lg transition-colors"
                              title="Editar"
                            >
                              <Edit2 className="w-3.5 h-3.5" />
                            </button>
                          )}
                          <button
                            onClick={(e) => { e.stopPropagation(); convertNoteToTask(note); }}
                            className={`p-1.5 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors ${
                              isFromOther ? 'text-blue-600' : 'text-yellow-600'
                            }`}
                            title="Convertir a tarea"
                          >
                            <CheckSquare className="w-3.5 h-3.5" />
                          </button>
                          <button
                            onClick={(e) => { e.stopPropagation(); convertNoteToJob(note); }}
                            className={`p-1.5 hover:text-orange-600 hover:bg-orange-50 rounded-lg transition-colors ${
                              isFromOther ? 'text-blue-600' : 'text-yellow-600'
                            }`}
                            title="Convertir a trabajo"
                          >
                            <Briefcase className="w-3.5 h-3.5" />
                          </button>
                          <button
                            onClick={(e) => { e.stopPropagation(); setArchiveConfirm({ type: 'note', item: note }); }}
                            className={`p-1.5 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors ${
                              isFromOther ? 'text-blue-600' : 'text-yellow-600'
                            }`}
                            title="Archivar"
                          >
                            <Archive className="w-3.5 h-3.5" />
                          </button>
                          <button
                            onClick={(e) => { e.stopPropagation(); deleteNote(note.id); }}
                            className={`p-1.5 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors ${
                              isFromOther ? 'text-blue-600' : 'text-yellow-600'
                            }`}
                            title="Eliminar"
                          >
                            <Trash2 className="w-3.5 h-3.5" />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                  {getNotesForSelectedDate().length === 0 && !showNewNote && (
                    <div className="flex-1 flex flex-col items-center justify-center py-8 text-center">
                      <div className="w-16 h-16 rounded-full bg-yellow-200 flex items-center justify-center mb-3">
                        <StickyNote className="w-8 h-8 text-yellow-500" />
                      </div>
                      <p className="text-sm text-yellow-700 font-medium">Sin notas</p>
                    </div>
                  )}
                </div>
              </div>

              {/* COLUMNA CENTRAL: TAREAS - AMARILLO */}
              <div
                className="flex flex-col overflow-hidden relative rounded-2xl"
                style={{
                  width: `${urgentWidth}%`,
                  background: 'linear-gradient(145deg, #FEE2E2 0%, #FECACA 100%)',
                  border: '1px solid #FECACA'
                }}
              >
                {/* Handle resize */}
                <div
                  onMouseDown={handleRightResize}
                  className="absolute right-0 top-0 bottom-0 w-2 cursor-col-resize hover:bg-yellow-600/10 z-10 select-none"
                  style={{ touchAction: 'none' }}
                />
                {/* Header limpio - solo icono, título y botón + */}
                <div className={`px-4 py-2 border-b ${selectedPriority === "todas" ? "bg-gradient-to-r from-purple-100 to-purple-200/80 border-purple-300/50" : selectedPriority === "alta" ? "bg-gradient-to-r from-red-100 to-red-200/80 border-red-300/50" : selectedPriority === "media" ? "bg-gradient-to-r from-orange-100 to-orange-200/80 border-orange-300/50" : "bg-gradient-to-r from-green-100 to-green-200/80 border-green-300/50"}`}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className={`w-7 h-7 rounded-lg flex items-center justify-center shadow-sm ${selectedPriority === "todas" ? "bg-purple-400" : selectedPriority === "alta" ? "bg-red-400" : selectedPriority === "media" ? "bg-orange-400" : "bg-green-400"}`}>
                        <CheckSquare className="w-3.5 h-3.5 text-white" />
                      </div>
                      <h3 className={`text-sm font-semibold ${selectedPriority === "todas" ? "text-purple-900" : selectedPriority === "alta" ? "text-red-900" : selectedPriority === "media" ? "text-orange-900" : "text-green-900"}`}>
                        {urgentType === 'todos' ? 'TTI' : urgentType === 'tareas' ? 'Tareas' : urgentType === 'trabajos' ? 'Trabajos' : 'Instalaciones'}
                      </h3>
                    </div>
                    <button
                      onClick={() => { setNewTaskForm(prev => ({...prev, priority: selectedPriority})); setShowNewTask(true); }}
                      className={`w-6 h-6 rounded-lg flex items-center justify-center transition-colors shadow-sm text-white ${selectedPriority === "todas" ? "bg-purple-500 hover:bg-purple-600" : selectedPriority === "alta" ? "bg-red-500 hover:bg-red-600" : selectedPriority === "media" ? "bg-orange-500 hover:bg-orange-600" : "bg-green-500 hover:bg-green-600"}`}
                    >
                      <Plus className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>

                {/* Lista de TTI (Tareas, Trabajos, Instalaciones) */}
                <div className={`flex-1 overflow-y-auto p-3 space-y-2 ${selectedPriority === "todas" ? "bg-purple-100/50" : selectedPriority === "alta" ? "bg-red-100/50" : selectedPriority === "media" ? "bg-orange-100/50" : "bg-green-100/50"}`}>
                  {(() => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    // Filtro de prioridad común
                    const priorityMatch = (item) => {
                      if (selectedPriority === 'todas') return true;
                      const p = item.priority;
                      if (selectedPriority === 'alta') return p === 'alta' || p === 'high';
                      if (selectedPriority === 'media') return p === 'media' || p === 'medium';
                      return p === 'baja' || p === 'low' || !p;
                    };

                    // Filtro de fecha: HOY = fecha seleccionada + retrasados, TODOS = todo
                    const selected = new Date(selectedDate);
                    selected.setHours(0, 0, 0, 0);

                    const dateMatch = (itemDate) => {
                      if (!itemDate) return calendarDateFilter === 'all';
                      const d = new Date(itemDate);
                      d.setHours(0, 0, 0, 0);
                      if (calendarDateFilter === 'all') return true;
                      // Si la fecha seleccionada es HOY: mostrar items de hoy + retrasados
                      // Si la fecha seleccionada es otra: mostrar SOLO items de esa fecha
                      const isSelectedToday = selected.getTime() === today.getTime();
                      if (isSelectedToday) {
                        return d.getTime() === selected.getTime() || d < today;
                      } else {
                        return d.getTime() === selected.getTime();
                      }
                    };

                    // Filtro especial para trabajos con rango de fechas (startDate - endDate)
                    const jobDateMatch = (job) => {
                      if (calendarDateFilter === 'all') return true;
                      if (!job.startDate && !job.endDate) return false;

                      const start = job.startDate ? new Date(job.startDate) : null;
                      const end = job.endDate ? new Date(job.endDate) : null;
                      if (start) start.setHours(0, 0, 0, 0);
                      if (end) end.setHours(23, 59, 59, 999);

                      const checkDate = new Date(selected);
                      checkDate.setHours(12, 0, 0, 0);

                      // Verificar si la fecha seleccionada está dentro del rango
                      const inRange = (!start || checkDate >= start) && (!end || checkDate <= end);

                      // Verificar si el trabajo está retrasado (endDate pasó)
                      const isDelayed = end && end < today;

                      // Si la fecha seleccionada es HOY: mostrar trabajos en rango + retrasados
                      // Si la fecha seleccionada es otra: mostrar SOLO trabajos en rango
                      const isSelectedToday = selected.getTime() === today.getTime();
                      if (isSelectedToday) {
                        return inRange || isDelayed;
                      } else {
                        return inRange;
                      }
                    };

                    // Filtro especial para instalaciones
                    const installDateMatch = (inst) => {
                      const instDate = inst.fechaPrevistaInstalacion || inst.installDate;
                      if (!instDate) return calendarDateFilter === 'all';
                      const d = new Date(instDate);
                      d.setHours(0, 0, 0, 0);
                      if (calendarDateFilter === 'all') return true;
                      // Si la fecha seleccionada es HOY: mostrar instalaciones de hoy + retrasadas
                      // Si la fecha seleccionada es otra: mostrar SOLO instalaciones de esa fecha
                      const isSelectedToday = selected.getTime() === today.getTime();
                      if (isSelectedToday) {
                        return d.getTime() === selected.getTime() || d < today;
                      } else {
                        return d.getTime() === selected.getTime();
                      }
                    };

                    // Calcular retraso
                    const getDelay = (itemDate) => {
                      if (!itemDate) return 0;
                      const d = new Date(itemDate);
                      d.setHours(0, 0, 0, 0);
                      const diff = Math.floor((today - d) / (1000 * 60 * 60 * 24));
                      return diff > 0 ? diff : 0;
                    };

                    if (urgentType === 'todos') {
                      // Combinar tareas, trabajos e instalaciones
                      const allItems = [];

                      // Tareas
                      tasks.filter(t => t.status !== 'completed' && priorityMatch(t) && dateMatch(t.dueDate || t.due_date))
                        .forEach(t => allItems.push({ ...t, _type: 'tarea', _date: t.dueDate || t.due_date }));

                      // Trabajos (usan rango de fechas startDate-endDate)
                      jobs.filter(j => j.status !== 'completed' && priorityMatch(j) && jobDateMatch(j))
                        .forEach(j => allItems.push({ ...j, _type: 'trabajo', _date: j.endDate || j.startDate }));

                      // Instalaciones (usan fechaPrevistaInstalacion o installDate)
                      installations.filter(i => i.status !== 'completed' && priorityMatch(i) && installDateMatch(i))
                        .forEach(i => allItems.push({ ...i, _type: 'instalacion', _date: i.fechaPrevistaInstalacion || i.installDate }));

                      // Ordenar por retraso
                      allItems.sort((a, b) => {
                        const delayA = getDelay(a._date);
                        const delayB = getDelay(b._date);
                        if (delayA > 0 && delayB === 0) return -1;
                        if (delayB > 0 && delayA === 0) return 1;
                        return delayB - delayA;
                      });

                      return allItems.length > 0 ? (
                        allItems.map(item => {
                          const itemDelay = getDelay(item._date);
                          const typeColor = item._type === 'tarea' ? 'amber' : item._type === 'trabajo' ? 'orange' : 'purple';
                          const typeLabel = item._type === 'tarea' ? 'T' : item._type === 'trabajo' ? 'TR' : 'I';
                          return (
                            <div
                              key={`${item._type}-${item.id}`}
                              className={`group rounded-xl p-3 transition-all shadow-sm hover:shadow border ${
                                itemDelay > 0 ? 'border-red-400 bg-red-100' :
                                (item.priority === 'alta' || item.priority === 'high') ? 'bg-red-50 border-red-200 hover:bg-red-100' :
                                (item.priority === 'media' || item.priority === 'medium') ? 'bg-orange-50 border-orange-200 hover:bg-orange-100' :
                                'bg-green-50 border-green-200 hover:bg-green-100'
                              }`}
                            >
                              <div className="flex items-start gap-2">
                                <div className={`w-5 h-5 rounded flex items-center justify-center text-[9px] font-bold text-white flex-shrink-0 bg-${typeColor}-500`}>
                                  {typeLabel}
                                </div>
                                <div className="flex-1 min-w-0">
                                  <p className={`text-sm font-medium truncate ${
                                    (item.priority === 'alta' || item.priority === 'high') ? 'text-red-900' :
                                    (item.priority === 'media' || item.priority === 'medium') ? 'text-orange-900' : 'text-green-900'
                                  }`}>{item.title || item.nombre}</p>
                                  <p className={`text-[11px] mt-0.5 flex items-center gap-1 ${
                                    itemDelay > 0 ? 'text-red-600 font-semibold' :
                                    (item.priority === 'alta' || item.priority === 'high') ? 'text-red-600' :
                                    (item.priority === 'media' || item.priority === 'medium') ? 'text-orange-600' : 'text-green-600'
                                  }`}>
                                    <Clock className="w-3 h-3" />
                                    {item._date ? new Date(item._date).toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }) : 'Sin fecha'}
                                    {itemDelay > 0 && <span className="ml-1 px-1.5 py-0.5 bg-red-500 text-white text-[10px] rounded font-bold">RETRASO</span>}
                                  </p>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="flex flex-col items-center justify-center py-8 text-center">
                          <div className="w-16 h-16 rounded-full bg-purple-200 flex items-center justify-center mb-3">
                            <CheckSquare className="w-8 h-8 text-purple-500" />
                          </div>
                          <p className="text-sm font-medium text-purple-700">Sin elementos</p>
                        </div>
                      );
                    } else if (urgentType === 'tareas') {
                      const filteredTasks = tasks.filter(t =>
                        t.status !== 'completed' &&
                        priorityMatch(t) &&
                        dateMatch(t.dueDate || t.due_date)
                      ).sort((a, b) => {
                        // Ordenar: retrasados primero, luego por fecha
                        const delayA = getDelay(a.dueDate || a.due_date);
                        const delayB = getDelay(b.dueDate || b.due_date);
                        if (delayA > 0 && delayB === 0) return -1;
                        if (delayB > 0 && delayA === 0) return 1;
                        return delayB - delayA;
                      });
                      return filteredTasks.length > 0 ? (
                        filteredTasks.map(task => {
                          const taskDelay = getDelay(task.dueDate || task.due_date);
                          return (
                            <div
                              key={task.id}
                              className={`group rounded-xl p-3 transition-all shadow-sm hover:shadow border ${
                                taskDelay > 0 ? 'border-red-400 bg-red-100' :
                                (task.priority === 'alta' || task.priority === 'high') ? 'bg-red-50 border-red-200 hover:bg-red-100' :
                                (task.priority === 'media' || task.priority === 'medium') ? 'bg-orange-50 border-orange-200 hover:bg-orange-100' :
                                'bg-green-50 border-green-200 hover:bg-green-100'
                              }`}
                            >
                              <div className="flex items-start gap-2">
                                <div className={`w-2 h-2 rounded-full mt-1.5 flex-shrink-0 ${
                                  (task.priority === 'alta' || task.priority === 'high') ? 'bg-red-500' :
                                  (task.priority === 'media' || task.priority === 'medium') ? 'bg-orange-500' : 'bg-green-500'
                                }`} />
                                <div className="flex-1 min-w-0">
                                  <p className={`text-sm font-medium truncate ${
                                    (task.priority === 'alta' || task.priority === 'high') ? 'text-red-900' :
                                    (task.priority === 'media' || task.priority === 'medium') ? 'text-orange-900' : 'text-green-900'
                                  }`}>{task.title}</p>
                                  <p className={`text-[11px] mt-0.5 flex items-center gap-1 ${
                                    taskDelay > 0 ? 'text-red-600 font-semibold' :
                                    (task.priority === 'alta' || task.priority === 'high') ? 'text-red-600' :
                                    (task.priority === 'media' || task.priority === 'medium') ? 'text-orange-600' : 'text-green-600'
                                  }`}>
                                    <Clock className="w-3 h-3" />
                                    {(task.dueDate || task.due_date) ? new Date(task.dueDate || task.due_date).toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }) : 'Sin fecha'}
                                    {taskDelay > 0 && <span className="ml-1 px-1.5 py-0.5 bg-red-500 text-white text-[10px] rounded font-bold">RETRASO</span>}
                                  </p>
                                </div>
                                <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                  <button
                                    onClick={(e) => { e.stopPropagation(); openEditTask(task); }}
                                    className={`p-1 rounded-lg transition-colors ${
                                      (task.priority === "alta" || task.priority === "high") ? "text-red-500 hover:bg-red-100" :
                                      (task.priority === "media" || task.priority === "medium") ? "text-orange-500 hover:bg-orange-100" : "text-green-500 hover:bg-green-100"
                                    }`}
                                  >
                                    <Edit2 className="w-3.5 h-3.5" />
                                  </button>
                                  <button
                                    onClick={(e) => { e.stopPropagation(); deleteTask(task.id); }}
                                    className="p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                                  >
                                    <Trash2 className="w-3.5 h-3.5" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="flex-1 flex flex-col items-center justify-center py-8 text-center">
                          <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-3 ${
                            selectedPriority === 'todas' ? 'bg-purple-200' : selectedPriority === 'alta' ? 'bg-red-200' :
                            selectedPriority === 'media' ? 'bg-orange-200' : 'bg-green-200'
                          }`}>
                            <CheckSquare className={`w-8 h-8 ${
                              selectedPriority === 'todas' ? 'text-purple-500' : selectedPriority === 'alta' ? 'text-red-500' :
                              selectedPriority === 'media' ? 'text-orange-500' : 'text-green-500'
                            }`} />
                          </div>
                          <p className={`text-sm font-medium ${
                            selectedPriority === 'todas' ? 'text-purple-700' : selectedPriority === 'alta' ? 'text-red-700' :
                            selectedPriority === 'media' ? 'text-orange-700' : 'text-green-700'
                          }`}>Sin tareas</p>
                        </div>
                      );
                    } else if (urgentType === 'trabajos') {
                      const filteredJobs = jobs.filter(j =>
                        j.status !== 'completed' &&
                        priorityMatch(j) &&
                        jobDateMatch(j)
                      ).sort((a, b) => {
                        const delayA = getDelay(a.endDate);
                        const delayB = getDelay(b.endDate);
                        if (delayA > 0 && delayB === 0) return -1;
                        if (delayB > 0 && delayA === 0) return 1;
                        return delayB - delayA;
                      });
                      return filteredJobs.length > 0 ? (
                        filteredJobs.map(job => {
                          const jobDelay = getDelay(job.endDate);
                          return (
                            <div
                              key={job.id}
                              className={`group rounded-xl p-3 transition-all shadow-sm hover:shadow border ${
                                jobDelay > 0 ? 'border-red-400 bg-red-100' :
                                (job.priority === 'alta' || job.priority === 'high') ? 'bg-red-50 border-red-200 hover:bg-red-100' :
                                (job.priority === 'media' || job.priority === 'medium') ? 'bg-orange-50 border-orange-200 hover:bg-orange-100' :
                                'bg-green-50 border-green-200 hover:bg-green-100'
                              }`}
                            >
                              <div className="flex items-start gap-2">
                                <div className={`w-2 h-2 rounded-full mt-1.5 flex-shrink-0 ${
                                  (job.priority === 'alta' || job.priority === 'high') ? 'bg-red-500' :
                                  (job.priority === 'media' || job.priority === 'medium') ? 'bg-orange-500' : 'bg-green-500'
                                }`} />
                                <div className="flex-1 min-w-0">
                                  <p className={`text-sm font-medium truncate ${
                                    (job.priority === 'alta' || job.priority === 'high') ? 'text-red-900' :
                                    (job.priority === 'media' || job.priority === 'medium') ? 'text-orange-900' : 'text-green-900'
                                  }`}>{job.title}</p>
                                  <p className={`text-[11px] mt-0.5 flex items-center gap-1 ${
                                    jobDelay > 0 ? 'text-red-600 font-semibold' :
                                    (job.priority === 'alta' || job.priority === 'high') ? 'text-red-600' :
                                    (job.priority === 'media' || job.priority === 'medium') ? 'text-orange-600' : 'text-green-600'
                                  }`}>
                                    <Clock className="w-3 h-3" />
                                    {job.endDate ? new Date(job.endDate).toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }) : 'Sin fecha'}
                                    {jobDelay > 0 && <span className="ml-1 px-1.5 py-0.5 bg-red-500 text-white text-[10px] rounded font-bold">RETRASO</span>}
                                  </p>
                                  {job.client && <p className="text-[10px] text-gray-500 truncate">{job.client}</p>}
                                </div>
                                <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                  <button
                                    onClick={(e) => { e.stopPropagation(); openEditJob(job); }}
                                    className={`p-1 rounded-lg transition-colors ${
                                      (job.priority === "alta" || job.priority === "high") ? "text-red-500 hover:bg-red-100" :
                                      (job.priority === "media" || job.priority === "medium") ? "text-orange-500 hover:bg-orange-100" : "text-green-500 hover:bg-green-100"
                                    }`}
                                  >
                                    <Edit2 className="w-3.5 h-3.5" />
                                  </button>
                                  <button
                                    onClick={(e) => { e.stopPropagation(); deleteJob(job.id); }}
                                    className="p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                                  >
                                    <Trash2 className="w-3.5 h-3.5" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="flex flex-col items-center justify-center py-6 text-center">
                          <Briefcase className={`w-8 h-8 mb-2 opacity-50 ${
                            selectedPriority === 'todas' ? 'text-purple-400' : selectedPriority === 'alta' ? 'text-red-400' :
                            selectedPriority === 'media' ? 'text-orange-400' : 'text-green-400'
                          }`} />
                          <p className={`text-xs ${
                            selectedPriority === 'todas' ? 'text-purple-600' : selectedPriority === 'alta' ? 'text-red-600' :
                            selectedPriority === 'media' ? 'text-orange-600' : 'text-green-600'
                          }`}>Sin trabajos</p>
                        </div>
                      );
                    } else {
                      // Instalaciones (usan fechaPrevistaInstalacion o installDate)
                      const filteredInst = installations.filter(i =>
                        i.status !== 'completed' &&
                        priorityMatch(i) &&
                        installDateMatch(i)
                      );
                      return filteredInst.length > 0 ? (
                        filteredInst.map(inst => (
                          <div
                            key={inst.id}
                            className={`group rounded-xl p-3 cursor-pointer transition-all shadow-sm hover:shadow border ${
                              getDelayDays(inst.fechaPrevistaInstalacion || inst.installDate) > 0 ? 'border-red-400 bg-red-100' :
                              (inst.priority === 'alta' || inst.priority === 'high') ? 'bg-red-50 border-red-200 hover:bg-red-100' :
                              (inst.priority === 'media' || inst.priority === 'medium') ? 'bg-orange-50 border-orange-200 hover:bg-orange-100' :
                              'bg-green-50 border-green-200 hover:bg-green-100'
                            }`}
                          >
                            <div className="flex items-start gap-2">
                              <div className={`w-2 h-2 rounded-full mt-1.5 flex-shrink-0 ${
                                (inst.priority === 'alta' || inst.priority === 'high') ? 'bg-red-500' :
                                (inst.priority === 'media' || inst.priority === 'medium') ? 'bg-orange-500' : 'bg-green-500'
                              }`} />
                              <div className="flex-1 min-w-0">
                                <p className={`text-sm font-medium truncate ${
                                  (inst.priority === 'alta' || inst.priority === 'high') ? 'text-red-900' :
                                  (inst.priority === 'media' || inst.priority === 'medium') ? 'text-orange-900' : 'text-green-900'
                                }`}>{inst.nombre}</p>
                                {listViewMode === 'date' && inst.fechaPrevistaInstalacion && (
                                  <p className={`text-[11px] mt-0.5 flex items-center gap-1 ${
                                    (inst.priority === 'alta' || inst.priority === 'high') ? 'text-red-600' :
                                    (inst.priority === 'media' || inst.priority === 'medium') ? 'text-orange-600' : 'text-green-600'
                                  }`}>
                                    <Clock className="w-3 h-3" />
                                    {new Date(inst.fechaPrevistaInstalacion).toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' })}
                                  </p>
                                )}
                                {listViewMode === "info" && job.client && (
                                  <p className={`text-[11px] mt-0.5 ${
                                    (inst.priority === 'alta' || inst.priority === 'high') ? 'text-red-600' :
                                    (inst.priority === 'media' || inst.priority === 'medium') ? 'text-orange-600' : 'text-green-600'
                                  }`}>{inst.localidad}</p>
                                )}
                              </div>
                              {getDelayDays(inst.fechaPrevistaInstalacion || inst.installDate) > 0 && (
                                <div className="flex-shrink-0 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded shadow-sm">
                                  RETRASO
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="flex flex-col items-center justify-center py-6 text-center">
                          <Wrench className={`w-8 h-8 mb-2 opacity-50 ${
                            selectedPriority === 'todas' ? 'text-purple-400' : selectedPriority === 'alta' ? 'text-red-400' :
                            selectedPriority === 'media' ? 'text-orange-400' : 'text-green-400'
                          }`} />
                          <p className={`text-xs ${
                            selectedPriority === 'todas' ? 'text-purple-600' : selectedPriority === 'alta' ? 'text-red-600' :
                            selectedPriority === 'media' ? 'text-orange-600' : 'text-green-600'
                          }`}>Sin instalaciones</p>
                        </div>
                      );
                    }
                  })()}
                </div>

              </div>

              {/* COLUMNA DERECHA: CALENDARIO - marco gris */}
              <div
                className="flex flex-col overflow-hidden bg-white rounded-xl border border-gray-300 mr-2"
                style={{
                  width: `${100 - notesWidth - urgentWidth}%`
                }}
              >
                {/* Header del calendario */}
                <div className="px-4 py-3 border-b border-gray-400 bg-gradient-to-r from-blue-50 to-indigo-50">
                  <div className="flex items-center justify-between">
                    <button
                      onClick={() => setCalendarMonth(new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() - 1))}
                      className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white/80 transition-colors"
                    >
                      <ChevronLeft className="w-5 h-5 text-gray-600" />
                    </button>
                    <div className="text-center">
                      <h3 className="text-base font-bold text-gray-900 capitalize">
                        {calendarMonth.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' })}
                      </h3>
                    </div>
                    <div className="flex items-center gap-1">
                      <button
                        onClick={() => { setSelectedDate(new Date()); setCalendarMonth(new Date()); }}
                        className="px-3 py-1.5 text-xs font-semibold text-white bg-blue-500 hover:bg-blue-600 rounded-lg transition-colors shadow-sm"
                        title="Ir a hoy"
                      >
                        Hoy
                      </button>
                      <button
                        onClick={() => setCalendarMonth(new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1))}
                        className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white/80 transition-colors"
                      >
                        <ChevronRight className="w-5 h-5 text-gray-600" />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Dias de la semana - header */}
                <div className="grid grid-cols-7 px-2 py-2 bg-gray-50/50">
                  {['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'].map((d, i) => (
                    <div
                      key={i}
                      className={`text-[10px] font-semibold text-center uppercase tracking-wide ${i >= 5 ? 'text-blue-500' : 'text-gray-500'}`}
                    >
                      {d}
                    </div>
                  ))}
                </div>

                {/* Dias del mes - grid moderno */}
                <div className="flex-1 grid grid-cols-7 grid-rows-6 gap-1 p-2">
                  {generateCalendarDays().map((day, i) => {
                    const isToday = day.date.toDateString() === new Date().toDateString();
                    const isSelected = day.date.toDateString() === selectedDate.toDateString();
                    const dayTasks = getTasksForDate(day.date);
                    const dayJobs = getJobsForDate(day.date);
                    const dayInstallations = getInstallationsForDate(day.date);
                    const holiday = getHolidayForDate(day.date);
                    const hasItems = dayTasks.length > 0 || dayJobs.length > 0 || dayInstallations.length > 0;
                    const isWeekend = i % 7 >= 5;
                    const dayNumber = day.date.getDate();

                    return (
                      <button
                        key={i}
                        className="group"
                        
                        onClick={() => {
                          setSelectedDate(day.date);
                          setCalendarDateFilter('today'); // Mostrar items de la fecha seleccionada

                          const dateStr = day.date.toISOString().split('T')[0];
                          const dayTasks = tasks.filter(t => (t.dueDate || t.due_date) && (t.dueDate || t.due_date).split('T')[0] === dateStr && t.status !== 'completed');
                          const dayJobs = jobs.filter(j => {
                            if (!j.startDate || !j.endDate) return false;
                            const s = new Date(j.startDate); s.setHours(0,0,0,0);
                            const e = new Date(j.endDate); e.setHours(23,59,59,999);
                            const check = new Date(day.date); check.setHours(12,0,0,0);
                            return check >= s && check <= e && j.status !== 'completed';
                          });
                          const dayInst = installations.filter(i => ((i.fechaPrevistaInstalacion && i.fechaPrevistaInstalacion.split('T')[0] === dateStr) || (i.installDate && i.installDate.split('T')[0] === dateStr)) && i.status !== 'completed');
                          const totalItems = dayTasks.length + dayJobs.length + dayInst.length;

                          // Mostrar el tipo correcto según lo que haya ese día
                          if (totalItems === 1) {
                            if (dayTasks.length === 1) {
                              setUrgentType('tareas');
                              const p = dayTasks[0].priority;
                              setSelectedPriority(p === 'high' ? 'alta' : p === 'medium' ? 'media' : p === 'low' ? 'baja' : p || 'todas');
                            } else if (dayJobs.length === 1) {
                              setUrgentType('trabajos');
                              const p = dayJobs[0].priority;
                              setSelectedPriority(p === 'high' ? 'alta' : p === 'medium' ? 'media' : p === 'low' ? 'baja' : p || 'todas');
                            } else {
                              setUrgentType('instalaciones');
                              setSelectedPriority('todas');
                            }
                          } else if (totalItems > 1) {
                            // Múltiples items: mostrar todos los tipos
                            setUrgentType('todos');
                            setSelectedPriority('todas');
                          } else {
                            // Sin items: mostrar todos para que vea que está vacío
                            setUrgentType('todos');
                            setSelectedPriority('todas');
                          }
                        }}
                        
                        className={`
                          group relative flex flex-col items-center justify-center rounded-lg transition-all duration-200
                          ${!day.currentMonth ? 'opacity-30' : ''}
                          ${holiday && day.currentMonth && !isToday && !isSelected ? 'bg-blue-200 text-blue-800' : ''}
                          ${isWeekend && day.currentMonth && !isToday && !isSelected && !holiday ? 'bg-blue-50 text-blue-600' : ''}
                          ${!isToday && !isSelected && day.currentMonth && !isWeekend && !holiday ? 'hover:bg-gray-100 text-gray-700' : ''}
                          ${(isWeekend || holiday) && day.currentMonth && !isToday && !isSelected ? 'hover:bg-blue-100' : ''}
                          ${isSelected && !isToday ? 'ring-2 ring-blue-500' : ''}
                          ${isToday ? 'text-gray-900 font-bold' : ''}
                        `}
                      >
                        {/* Esquinas rojas para el día actual */}
                        {isToday && day.currentMonth && (
                          <>
                            <span className="absolute top-0 left-0 w-2.5 h-2.5 border-t-[3px] border-l-[3px] border-red-500" />
                            <span className="absolute top-0 right-0 w-2.5 h-2.5 border-t-[3px] border-r-[3px] border-red-500" />
                            <span className="absolute bottom-0 left-0 w-2.5 h-2.5 border-b-[3px] border-l-[3px] border-red-500" />
                            <span className="absolute bottom-0 right-0 w-2.5 h-2.5 border-b-[3px] border-r-[3px] border-red-500" />
                          </>
                        )}
                        <span className={`text-sm font-semibold ${isToday ? 'font-bold' : ''}`}>
                          {dayNumber}
                        </span>
                        
                        {/* Indicadores de eventos - puntos de colores */}
                        {hasItems && day.currentMonth && (
                          <div className="flex gap-0.5 mt-0.5">
                            {dayTasks.length > 0 && (
                              <span className="w-1.5 h-1.5 rounded-full bg-amber-400" title="Tareas" />
                            )}
                            {dayJobs.length > 0 && (
                              <span className="w-1.5 h-1.5 rounded-full bg-orange-400" title="Trabajos" />
                            )}
                            {dayInstallations.length > 0 && (
                              <span className="w-1.5 h-1.5 rounded-full bg-purple-400" title="Instalaciones" />
                            )}
                          </div>
                        )}
                        {/* Tooltip para festivos */}
                        {holiday && day.currentMonth && (
                          <div className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-blue-600 text-white text-sm font-bold rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                            {holiday.name}
                            <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-blue-600" />
                          </div>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Contenedor de controles - debajo de los 3 post-its */}
            <div className="flex items-center justify-between py-1.5 mx-4 mt-1 bg-gray-50 rounded-lg border border-gray-200 px-3">
              {/* Contenido plegable */}
              {!filtersCollapsed && (
                <div className="flex items-center justify-between flex-1">
                  {/* Espacio vacío a la izquierda (bajo NOTAS) */}
                  <div style={{ width: `${notesWidth}%` }}></div>

                  {/* Filtros - bajo el post-it de TAREAS */}
                  <div style={{ width: `${urgentWidth}%` }} className="flex items-center justify-center gap-2">
                    <select
                      value={urgentType}
                      onChange={(e) => setUrgentType(e.target.value)}
                      className="text-[11px] font-medium bg-white border border-gray-300 rounded-lg px-2 py-1 focus:outline-none cursor-pointer"
                    >
                      <option value="todos">TODOS</option>
                      <option value="tareas">TAREAS</option>
                      <option value="trabajos">TRABAJOS</option>
                      <option value="instalaciones">INSTALACIONES</option>
                    </select>

                    <select
                      value={selectedPriority}
                      onChange={(e) => setSelectedPriority(e.target.value)}
                      className="text-[11px] font-medium bg-white border border-gray-300 rounded-lg px-2 py-1 focus:outline-none cursor-pointer"
                    >
                      <option value="todas">TODOS</option>
                      <option value="alta">URGENTES</option>
                      <option value="media">MEDIOS</option>
                      <option value="baja">NORMALES</option>
                    </select>

                    <div className="flex items-center gap-1 bg-white rounded-lg p-0.5 border border-gray-300">
                      <button
                        onClick={() => setCalendarDateFilter('today')}
                        className={`px-2 py-1 text-[10px] font-semibold rounded-md transition-all ${
                          calendarDateFilter === 'today' ? 'bg-blue-500 text-white' : 'text-gray-600 hover:bg-gray-200'
                        }`}
                      >
                        HOY
                      </button>
                      <button
                        onClick={() => setCalendarDateFilter('all')}
                        className={`px-2 py-1 text-[10px] font-semibold rounded-md transition-all ${
                          calendarDateFilter === 'all' ? 'bg-blue-500 text-white' : 'text-gray-600 hover:bg-gray-200'
                        }`}
                      >
                        TODOS
                      </button>
                    </div>
                  </div>

                  {/* Leyenda de colores - bajo CALENDARIO */}
                  <div style={{ width: `${100 - notesWidth - urgentWidth}%` }} className="flex items-center justify-center gap-4 text-xs font-medium text-gray-600">
                    <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-amber-400"></span> Tareas</span>
                    <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-orange-400"></span> Trabajos</span>
                    <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-purple-400"></span> Instalaciones</span>
                  </div>
                </div>
              )}

              {/* Botón FILTROS para plegar/desplegar */}
              <button
                onClick={() => setFiltersCollapsed(!filtersCollapsed)}
                className="flex items-center gap-1 text-[11px] font-bold text-gray-500 hover:text-gray-700 uppercase tracking-wider ml-auto"
              >
                <span>FILTROS</span>
                <ChevronDown className={`w-4 h-4 transition-transform ${filtersCollapsed ? '' : 'rotate-180'}`} />
              </button>
            </div>

          </div>
        )}

        {/* Resize altura - barra interactiva para redimensionar */}
        {!headerCollapsed && (
          <div
            onMouseDown={handleHeightResize}
            className={`h-1.5 cursor-row-resize transition-colors select-none mx-4 rounded-full ${isResizingHeight ? 'bg-blue-400' : 'bg-transparent hover:bg-gray-300'}`}
            style={{ touchAction: 'none' }}
          />
        )}
      </div>

      {/* Tabs de navegacion - estilo moderno */}
      <div className="px-4 py-3 bg-white border-t border-gray-400">
        <div className="flex items-center gap-2 bg-gray-100 rounded-xl p-1">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            const count = tab.id === 'tareas'
              ? tasks.filter(t => t.status !== 'completed').length
              : tab.id === 'trabajos'
              ? jobs.filter(j => j.status !== 'completed').length
              : tab.id === 'instalaciones'
              ? installations.filter(i => i.status !== 'completed').length
              : tasks.filter(t => t.status === 'completed').length + jobs.filter(j => j.status === 'completed').length + installations.filter(i => i.status === 'completed').length;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg transition-all duration-200 ${
                  isActive
                    ? 'bg-white text-blue-600 shadow-sm font-semibold'
                    : 'text-gray-500 hover:text-gray-700 hover:bg-white/50'
                }`}
              >
                <Icon className={`w-4 h-4 ${isActive ? 'text-blue-500' : 'text-gray-400'}`} />
                <span className="text-sm">{tab.label}</span>
                {count > 0 && (
                  <span className={`px-2 py-0.5 text-xs font-semibold rounded-full ${
                    isActive ? 'bg-blue-100 text-blue-600' : 'bg-gray-200 text-gray-600'
                  }`}>
                    {count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Content - area principal de trabajo */}
      <div className="flex-1 overflow-auto p-4 bg-white/50">
        {activeTab === 'tareas' && renderTareas()}
        {activeTab === 'trabajos' && renderTrabajos()}
        {activeTab === 'instalaciones' && renderInstalaciones()}
        {activeTab === 'logs' && renderLogs()}
      </div>

      {/* Modal Nueva/Editar Tarea */}
      {showNewTask && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={closeTaskModal}>
          <div className="bg-white rounded-xl shadow-2xl w-[500px] max-w-[90vw] max-h-[90vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between p-4 border-b bg-gray-50">
              <h3 className="text-lg font-semibold text-gray-900">
                {editingTask ? 'Editar Tarea' : 'Nueva Tarea'}
              </h3>
              <button onClick={closeTaskModal} className="p-1 hover:bg-gray-200 rounded">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-4 space-y-4 overflow-y-auto">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Título *</label>
                <input
                  type="text"
                  value={newTaskForm.title}
                  onChange={(e) => setNewTaskForm({...newTaskForm, title: e.target.value})}
                  placeholder="Ej: Revisar tickets pendientes"
                  className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                  autoFocus
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Descripción</label>
                <textarea
                  value={newTaskForm.description}
                  onChange={(e) => setNewTaskForm({...newTaskForm, description: e.target.value})}
                  placeholder="Detalles de la tarea..."
                  rows={2}
                  className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6] resize-none"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fecha</label>
                  <input
                    type="date"
                    value={newTaskForm.dueDate}
                    onChange={(e) => setNewTaskForm({...newTaskForm, dueDate: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Hora</label>
                  <input
                    type="time"
                    value={newTaskForm.dueTime}
                    onChange={(e) => setNewTaskForm({...newTaskForm, dueTime: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Prioridad</label>
                  <select
                    value={newTaskForm.priority}
                    onChange={(e) => setNewTaskForm({...newTaskForm, priority: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                  >
                    <option value="alta">Alta</option>
                    <option value="media">Media</option>
                    <option value="baja">Baja</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Asignar a</label>
                  <select
                    value={newTaskForm.assignee}
                    onChange={(e) => setNewTaskForm({...newTaskForm, assignee: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                  >
                    <option value="">Sin asignar</option>
                    {users.map(u => (
                      <option key={u.id} value={u.id}>
                        {u.name} {u.department ? `(${u.department})` : u.role ? `(${u.role})` : ''}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <StickyNote className="w-4 h-4 inline mr-1" />
                  Notas
                </label>
                <textarea
                  value={newTaskForm.notes}
                  onChange={(e) => setNewTaskForm({...newTaskForm, notes: e.target.value})}
                  placeholder="Notas adicionales..."
                  rows={2}
                  className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6] resize-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <Link2 className="w-4 h-4 inline mr-1" />
                  Enlace Trello
                </label>
                <input
                  type="url"
                  value={newTaskForm.trelloLink}
                  onChange={(e) => setNewTaskForm({...newTaskForm, trelloLink: e.target.value})}
                  placeholder="https://trello.com/c/..."
                  className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                />
              </div>
              {/* Etiquetas de colores */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Etiquetas</label>
                <div className="flex flex-wrap gap-2">
                  {LABEL_COLORS.map(label => (
                    <button
                      key={label.id}
                      type="button"
                      onClick={() => toggleTaskLabel(label.id)}
                      className={`w-8 h-8 rounded-lg transition-all ${label.bg} ${
                        newTaskForm.labels.includes(label.id)
                          ? 'ring-2 ring-offset-2 ring-gray-400 scale-110'
                          : 'opacity-60 hover:opacity-100'
                      }`}
                      title={label.label}
                    />
                  ))}
                </div>
                {newTaskForm.labels.length > 0 && (
                  <p className="text-xs text-gray-500 mt-2">
                    Seleccionadas: {newTaskForm.labels.map(l => LABEL_COLORS.find(c => c.id === l)?.label).join(', ')}
                  </p>
                )}
              </div>
            </div>
            <div className="flex items-center justify-end gap-3 p-4 border-t bg-gray-50">
              <button
                onClick={closeTaskModal}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={editingTask ? updateTask : createTask}
                className="px-4 py-2 bg-[#3B82F6] text-white rounded-lg hover:bg-[#2563EB] transition-colors"
              >
                {editingTask ? 'Guardar Cambios' : 'Crear Tarea'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Nuevo/Editar Trabajo */}
      {showNewJob && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={closeJobModal}>
          <div className="bg-white rounded-xl shadow-2xl w-[550px] max-w-full max-h-[90vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between p-4 border-b bg-gray-50">
              <h3 className="text-lg font-semibold text-gray-900">
                {editingJob ? 'Editar Trabajo' : 'Nuevo Trabajo'}
              </h3>
              <button onClick={closeJobModal} className="p-1 hover:bg-gray-200 rounded">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-4 space-y-4 overflow-y-auto">
              {/* Título */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Título *</label>
                <input
                  type="text"
                  value={newJobForm.title}
                  onChange={(e) => setNewJobForm({...newJobForm, title: e.target.value})}
                  placeholder="Ej: Instalación taquilla Madrid"
                  className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                  autoFocus
                />
              </div>

              {/* Cliente + Tipo */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Cliente</label>
                  <input
                    type="text"
                    value={newJobForm.client}
                    onChange={(e) => setNewJobForm({...newJobForm, client: e.target.value})}
                    placeholder="Nombre del cliente"
                    className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                  />
                </div>
              </div>

              {/* Tipo de trabajo - botones con iconos */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de trabajo</label>
                <div className="grid grid-cols-3 gap-2">
                  {JOB_TYPES.map(type => {
                    const TypeIcon = type.icon;
                    const isSelected = newJobForm.type === type.id;
                    return (
                      <button
                        key={type.id}
                        type="button"
                        onClick={() => setNewJobForm({...newJobForm, type: type.id})}
                        className={`flex flex-col items-center gap-1 p-3 rounded-xl border transition-all ${
                          isSelected
                            ? 'border-[#3B82F6] bg-blue-50 text-[#3B82F6]'
                            : 'border-gray-500 hover:border-gray-500 text-gray-600 hover:bg-gray-50'
                        }`}
                      >
                        <TypeIcon className={`w-5 h-5 ${isSelected ? 'text-[#3B82F6]' : 'text-gray-400'}`} />
                        <span className="text-xs font-medium">{type.label}</span>
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Descripción */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Descripción</label>
                <textarea
                  value={newJobForm.description}
                  onChange={(e) => setNewJobForm({...newJobForm, description: e.target.value})}
                  placeholder="Detalles del trabajo..."
                  rows={2}
                  className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6] resize-none"
                />
              </div>

              {/* Rango de fechas */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Rango de fechas</label>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">Desde</label>
                    <input
                      type="date"
                      value={newJobForm.startDate}
                      onChange={(e) => setNewJobForm({...newJobForm, startDate: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-gray-500 mb-1">Hasta</label>
                    <input
                      type="date"
                      value={newJobForm.endDate}
                      onChange={(e) => setNewJobForm({...newJobForm, endDate: e.target.value})}
                      min={newJobForm.startDate}
                      className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                    />
                  </div>
                </div>
              </div>

              {/* Estado */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
                <select
                  value={newJobForm.status}
                  onChange={(e) => setNewJobForm({...newJobForm, status: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                >
                  <option value="pending">Pendiente</option>
                  <option value="in_progress">En progreso</option>
                  <option value="completed">Completado</option>
                </select>
              </div>

              {/* Etiquetas de colores */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Etiquetas</label>
                <div className="flex flex-wrap gap-2">
                  {LABEL_COLORS.map(label => (
                    <button
                      key={label.id}
                      type="button"
                      onClick={() => toggleJobLabel(label.id)}
                      className={`w-8 h-8 rounded-lg transition-all ${label.bg} ${
                        newJobForm.labels.includes(label.id)
                          ? 'ring-2 ring-offset-2 ring-gray-400 scale-110'
                          : 'opacity-60 hover:opacity-100'
                      }`}
                      title={label.label}
                    />
                  ))}
                </div>
                {newJobForm.labels.length > 0 && (
                  <p className="text-xs text-gray-500 mt-2">
                    Seleccionadas: {newJobForm.labels.map(l => LABEL_COLORS.find(c => c.id === l)?.label).join(', ')}
                  </p>
                )}
              </div>

              {/* Notas */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <StickyNote className="w-4 h-4 inline mr-1" />
                  Notas
                </label>
                <textarea
                  value={newJobForm.notes}
                  onChange={(e) => setNewJobForm({...newJobForm, notes: e.target.value})}
                  placeholder="Notas adicionales..."
                  rows={2}
                  className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6] resize-none"
                />
              </div>

              {/* Enlace Trello */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <Link2 className="w-4 h-4 inline mr-1" />
                  Enlace Trello
                </label>
                <input
                  type="url"
                  value={newJobForm.trelloLink}
                  onChange={(e) => setNewJobForm({...newJobForm, trelloLink: e.target.value})}
                  placeholder="https://trello.com/c/..."
                  className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-[#3B82F6]"
                />
              </div>
            </div>
            <div className="flex items-center justify-end gap-3 p-4 border-t bg-gray-50">
              <button
                onClick={closeJobModal}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={editingJob ? updateJob : createJob}
                className="px-4 py-2 bg-[#3B82F6] text-white rounded-lg hover:bg-[#2563EB] transition-colors"
              >
                {editingJob ? 'Guardar Cambios' : 'Crear Trabajo'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Historial de Notas Enviadas */}
      {showSentNotes && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowSentNotes(false)}>
          <div className="bg-white rounded-xl shadow-2xl w-[600px] max-w-[95vw] max-h-[80vh] flex flex-col" onClick={e => e.stopPropagation()}>
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b bg-blue-500 rounded-t-xl">
              <h3 className="font-semibold text-white">Notas Enviadas ({getSentNotes().length})</h3>
              <button onClick={() => setShowSentNotes(false)} className="p-1 hover:bg-blue-600 rounded text-white">
                <X className="w-5 h-5" />
              </button>
            </div>
            {/* Content */}
            <div className="flex-1 overflow-y-auto p-4">
              {getSentNotes().length === 0 ? (
                <div className="text-center py-12 text-gray-400">
                  <p>No has enviado notas a compañeros</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {getSentNotes().map(note => (
                    <div key={note.id} className="bg-gray-50 p-3 rounded-lg border">
                      {/* Header nota */}
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-sm font-medium text-gray-700">
                          Para: {note.recipient?.full_name || 'Compañero'}
                        </span>
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => {
                              setEditingNote(note);
                              setNewNoteText(note.text);
                              setShowSentNotes(false);
                              setShowNewNote(true);
                            }}
                            className="p-1 text-gray-400 hover:text-blue-500 rounded"
                          >
                            <Edit2 className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => deleteNote(note.id)}
                            className="p-1 text-gray-400 hover:text-red-500 rounded"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                      {/* Texto */}
                      <p className="text-sm text-gray-600 mb-2">{note.text}</p>
                      {/* Footer */}
                      <div className="flex items-center justify-between text-xs">
                        <span className="text-gray-400">
                          {new Date(note.created_at).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                        </span>
                        {/* Checks WhatsApp */}
                        {note.is_read ? (
                          <span className="text-blue-500 font-medium">✓✓ Leído</span>
                        ) : (
                          <span className="text-gray-400">✓ Enviado</span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Nueva Instalación - no se cierra al clicar fuera */}
      {showNewInstallation && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-[900px] max-w-[95vw] max-h-[95vh] overflow-hidden flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b bg-gray-50">
              <h3 className="text-lg font-semibold text-gray-900">Nueva Instalación</h3>
              <button onClick={() => setShowNewInstallation(false)} className="p-1 hover:bg-gray-200 rounded">
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Tabs */}
            <div className="flex border-b bg-white">
              {['datos', 'departamentos', 'material', 'diseño', 'entradas', 'administracion', 'pagos', 'instalacion', 'archivos'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setInstallationTab(tab)}
                  className={`px-4 py-2 text-sm font-medium capitalize transition-colors ${
                    installationTab === tab
                      ? 'text-blue-600 border-b-2 border-blue-600'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* Content */}
            <div className="p-4 space-y-4 overflow-y-auto flex-1">
              {/* TAB: Datos */}
              {installationTab === 'datos' && (
                <>
                  <div className="bg-gray-50 rounded-xl p-4">
                    <h4 className="font-semibold text-gray-800 mb-3">Datos del lugar</h4>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Nº Contrato / ID</label>
                        <input type="text" value={newInstallationForm.idContrato}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, idContrato: e.target.value})}
                          placeholder="Ej: 2026-001" className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del lugar</label>
                        <input type="text" value={newInstallationForm.nombre}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, nombre: e.target.value})}
                          placeholder="Teatro Principal" className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
                        <select value={newInstallationForm.tipo}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, tipo: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm">
                          {TIPOS_LUGAR.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
                        <input type="tel" value={newInstallationForm.telefono}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, telefono: e.target.value})}
                          placeholder="912 345 678" className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                      </div>
                      <div className="col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Dirección</label>
                        <input type="text" value={newInstallationForm.direccion}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, direccion: e.target.value})}
                          placeholder="Calle..." className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Localidad</label>
                        <input type="text" value={newInstallationForm.localidad}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, localidad: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Provincia</label>
                        <select value={newInstallationForm.provincia}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, provincia: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm">
                          <option value="">Selecciona...</option>
                          {PROVINCIAS.map(p => <option key={p} value={p}>{p}</option>)}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Persona de contacto</label>
                        <input type="text" value={newInstallationForm.personaContacto}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, personaContacto: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-xl p-4">
                    <h4 className="font-semibold text-gray-800 mb-3">Datos del contrato</h4>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Fecha firma</label>
                        <input type="date" value={newInstallationForm.fechaFirma}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, fechaFirma: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Duración (meses)</label>
                        <select value={newInstallationForm.duracionContrato}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, duracionContrato: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm">
                          <option value="6">6 meses</option>
                          <option value="12">12 meses (1 año)</option>
                          <option value="24">24 meses (2 años)</option>
                          <option value="36">36 meses (3 años)</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Nº Ampliaciones</label>
                        <input type="number" min="0" value={newInstallationForm.numAmpliaciones}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, numAmpliaciones: parseInt(e.target.value) || 0})}
                          className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Duración ampliación</label>
                        <select value={newInstallationForm.duracionAmpliacion}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, duracionAmpliacion: e.target.value})}
                          disabled={newInstallationForm.numAmpliaciones === 0}
                          className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm disabled:opacity-50">
                          <option value="6">6 meses</option>
                          <option value="12">12 meses (1 año)</option>
                          <option value="24">24 meses (2 años)</option>
                        </select>
                      </div>
                      {newInstallationForm.numAmpliaciones > 0 && (
                        <div className="col-span-2 text-sm text-gray-500">
                          Total contrato: {Math.floor(parseInt(newInstallationForm.duracionContrato) / 12) || newInstallationForm.duracionContrato + 'm'}
                          {Array.from({length: newInstallationForm.numAmpliaciones}, () =>
                            '+' + (Math.floor(parseInt(newInstallationForm.duracionAmpliacion) / 12) || newInstallationForm.duracionAmpliacion + 'm')
                          ).join('')}
                        </div>
                      )}
                      <div className="col-span-2">
                        <label className="flex items-center gap-2 cursor-pointer">
                          <input type="checkbox" checked={newInstallationForm.crearAlarma}
                            onChange={(e) => setNewInstallationForm({...newInstallationForm, crearAlarma: e.target.checked})}
                            className="w-4 h-4 text-blue-600 rounded" />
                          <span className="text-sm text-gray-700">Crear alarma antes de expiración</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* TAB: Departamentos */}
              {installationTab === 'departamentos' && (
                <div className="bg-gray-50 rounded-xl p-4">
                  <h4 className="font-semibold text-gray-800 mb-3">Departamentos involucrados</h4>
                  <p className="text-sm text-gray-500 mb-4">Selecciona los departamentos que participarán</p>
                  <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                    {[
                      { key: 'deptEntradas', label: 'Entradas', color: 'blue', icon: FileText },
                      { key: 'deptDiseno', label: 'Diseño', color: 'purple', icon: LayoutGrid },
                      { key: 'deptSAT', label: 'SAT', color: 'orange', icon: Wrench },
                      { key: 'deptComercial', label: 'Comercial', color: 'green', icon: Briefcase },
                      { key: 'deptAdministracion', label: 'Administración', color: 'pink', icon: Settings }
                    ].map(dept => (
                      <div key={dept.key}
                        onClick={() => setNewInstallationForm({...newInstallationForm, [dept.key]: !newInstallationForm[dept.key]})}
                        className={`p-4 rounded-xl border-2 cursor-pointer transition-all text-center ${
                          newInstallationForm[dept.key] ? `border-${dept.color}-500 bg-${dept.color}-50` : 'border-gray-500 bg-white hover:border-gray-500'
                        }`}>
                        <div className={`w-12 h-12 mx-auto mb-2 rounded-full flex items-center justify-center ${
                          newInstallationForm[dept.key] ? `bg-${dept.color}-500 text-white` : 'bg-gray-100 text-gray-500'
                        }`}>
                          <dept.icon className="w-6 h-6" />
                        </div>
                        <span className={`font-medium ${newInstallationForm[dept.key] ? `text-${dept.color}-700` : 'text-gray-700'}`}>{dept.label}</span>
                      </div>
                    ))}
                  </div>
                  {!(newInstallationForm.deptEntradas || newInstallationForm.deptDiseno || newInstallationForm.deptSAT || newInstallationForm.deptComercial || newInstallationForm.deptAdministracion) && (
                    <p className="text-sm text-red-500 mt-4">* Debes seleccionar al menos un departamento</p>
                  )}
                </div>
              )}

              {/* TAB: Material */}
              {installationTab === 'material' && (
                <div className="bg-gray-50 rounded-xl p-4 space-y-4">
                  <h4 className="font-semibold text-gray-800 mb-3">Material y servicios</h4>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Descripción del material</label>
                    <textarea value={newInstallationForm.materialInstalar}
                      onChange={(e) => setNewInstallationForm({...newInstallationForm, materialInstalar: e.target.value})}
                      placeholder="TPVs, impresoras, pinpads..." rows={3}
                      className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm resize-none" />
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <label className="flex items-center gap-2 p-3 bg-white rounded-lg border cursor-pointer">
                      <input type="checkbox" checked={newInstallationForm.ponemosInternet}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, ponemosInternet: e.target.checked})}
                        className="w-4 h-4 text-blue-600 rounded" />
                      <span className="text-sm">¿Ponemos internet?</span>
                    </label>
                    <label className="flex items-center gap-2 p-3 bg-white rounded-lg border cursor-pointer">
                      <input type="checkbox" checked={newInstallationForm.llevaWeb}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, llevaWeb: e.target.checked})}
                        className="w-4 h-4 text-blue-600 rounded" />
                      <span className="text-sm">¿Lleva web?</span>
                    </label>
                    <label className="flex items-center gap-2 p-3 bg-white rounded-lg border cursor-pointer">
                      <input type="checkbox" checked={newInstallationForm.llevaPapel}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, llevaPapel: e.target.checked})}
                        className="w-4 h-4 text-blue-600 rounded" />
                      <span className="text-sm">¿Lleva papel?</span>
                    </label>
                  </div>
                  {newInstallationForm.llevaPapel && (
                    <div className="pl-4 border-l-2 border-blue-200 space-y-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Tipos de papel</label>
                        <div className="flex gap-3">
                          {['rollo', 'entradas_bonitas'].map(tipo => (
                            <label key={tipo} className="flex items-center gap-2 cursor-pointer">
                              <input type="checkbox"
                                checked={newInstallationForm.tiposPapel.includes(tipo)}
                                onChange={(e) => {
                                  const tipos = e.target.checked
                                    ? [...newInstallationForm.tiposPapel, tipo]
                                    : newInstallationForm.tiposPapel.filter(t => t !== tipo);
                                  setNewInstallationForm({...newInstallationForm, tiposPapel: tipos});
                                }}
                                className="w-4 h-4 text-blue-600 rounded" />
                              <span className="text-sm">{tipo === 'rollo' ? 'Rollo' : 'Entradas bonitas'}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Cantidad</label>
                        <input type="text" value={newInstallationForm.cantidadPapel}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, cantidadPapel: e.target.value})}
                          placeholder="10 rollos, 5 cajas..." className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* TAB: Diseño */}
              {installationTab === 'diseño' && (
                <div className="bg-gray-50 rounded-xl p-4 space-y-4">
                  <h4 className="font-semibold text-gray-800 mb-3">Diseño</h4>
                  <div className="grid grid-cols-2 gap-4">
                    <label className="flex items-center gap-2 p-3 bg-white rounded-lg border cursor-pointer">
                      <input type="checkbox" checked={newInstallationForm.dibujarTeatro}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, dibujarTeatro: e.target.checked})}
                        className="w-4 h-4 text-blue-600 rounded" />
                      <span className="text-sm">¿Dibujar teatro/sala?</span>
                    </label>
                    <label className="flex items-center gap-2 p-3 bg-white rounded-lg border cursor-pointer">
                      <input type="checkbox" checked={newInstallationForm.disenoEntradas}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, disenoEntradas: e.target.checked})}
                        className="w-4 h-4 text-blue-600 rounded" />
                      <span className="text-sm">Diseño de entradas</span>
                    </label>
                    <label className="flex items-center gap-2 p-3 bg-white rounded-lg border cursor-pointer">
                      <input type="checkbox" checked={newInstallationForm.disenoCarteleria}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, disenoCarteleria: e.target.checked})}
                        className="w-4 h-4 text-blue-600 rounded" />
                      <span className="text-sm">Diseño cartelería</span>
                    </label>
                    <label className="flex items-center gap-2 p-3 bg-white rounded-lg border cursor-pointer">
                      <input type="checkbox" checked={newInstallationForm.disenoWeb}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, disenoWeb: e.target.checked})}
                        className="w-4 h-4 text-blue-600 rounded" />
                      <span className="text-sm">Diseño web</span>
                    </label>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Notas de diseño</label>
                    <textarea value={newInstallationForm.notasDiseño}
                      onChange={(e) => setNewInstallationForm({...newInstallationForm, notasDiseño: e.target.value})}
                      placeholder="Especificaciones de diseño..." rows={3}
                      className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm resize-none" />
                  </div>
                </div>
              )}

              {/* TAB: Entradas */}
              {installationTab === 'entradas' && (
                <div className="bg-gray-50 rounded-xl p-4 space-y-4">
                  <h4 className="font-semibold text-gray-800 mb-3">Entradas - Personal y recursos</h4>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Nº Taquillas a crear</label>
                      <input type="number" min="0" value={newInstallationForm.numTaquillas}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, numTaquillas: e.target.value})}
                        placeholder="0" className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Nº Guías</label>
                      <input type="number" min="0" value={newInstallationForm.numGuias}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, numGuias: e.target.value})}
                        placeholder="0" className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Nº Lectoristas</label>
                      <input type="number" min="0" value={newInstallationForm.numLectoristas}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, numLectoristas: e.target.value})}
                        placeholder="0" className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Notas para Entradas</label>
                    <textarea value={newInstallationForm.notasEntradas}
                      onChange={(e) => setNewInstallationForm({...newInstallationForm, notasEntradas: e.target.value})}
                      placeholder="Observaciones para el departamento de Entradas..." rows={3}
                      className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm resize-none" />
                  </div>
                </div>
              )}

              {/* TAB: Administración */}
              {installationTab === 'administracion' && (
                <div className="bg-gray-50 rounded-xl p-4 space-y-4">
                  <h4 className="font-semibold text-gray-800 mb-3">Administración</h4>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">¿Dónde va el dinero?</label>
                      <select value={newInstallationForm.dineroDestino}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, dineroDestino: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm">
                        <option value="manantial">A Manantial</option>
                        <option value="propiedad">A la Propiedad</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Forma de pago</label>
                      <select value={newInstallationForm.formaPago}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, formaPago: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm">
                        <option value="transferencia">Transferencia</option>
                        <option value="domiciliacion">Domiciliación</option>
                        <option value="efectivo">Efectivo</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Duración contrato</label>
                      <select value={newInstallationForm.duracionContrato}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, duracionContrato: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm">
                        <option value="6">6 meses</option>
                        <option value="12">12 meses (1 año)</option>
                        <option value="24">24 meses (2 años)</option>
                        <option value="36">36 meses (3 años)</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Tipo comisión</label>
                      <select value={newInstallationForm.tipoComision}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, tipoComision: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm">
                        <option value="fijo">Importe fijo</option>
                        <option value="porcentaje">Porcentaje</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Valor comisión {newInstallationForm.tipoComision === 'porcentaje' ? '(%)' : '(€)'}
                      </label>
                      <input type="number" value={newInstallationForm.comisionValor}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, comisionValor: e.target.value})}
                        placeholder={newInstallationForm.tipoComision === 'porcentaje' ? '10' : '0.50'}
                        className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                    </div>
                    <label className="flex items-center gap-2 p-3 bg-white rounded-lg border cursor-pointer">
                      <input type="checkbox" checked={newInstallationForm.llevaPinpad}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, llevaPinpad: e.target.checked})}
                        className="w-4 h-4 text-blue-600 rounded" />
                      <span className="text-sm">¿Lleva Pinpad?</span>
                    </label>
                    <label className="flex items-center gap-2 p-3 bg-white rounded-lg border cursor-pointer">
                      <input type="checkbox" checked={newInstallationForm.facturacionMensual}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, facturacionMensual: e.target.checked})}
                        className="w-4 h-4 text-blue-600 rounded" />
                      <span className="text-sm">Facturación mensual</span>
                    </label>
                  </div>
                </div>
              )}

              {/* TAB: Pagos */}
              {installationTab === 'pagos' && (
                <div className="bg-gray-50 rounded-xl p-4 space-y-4">
                  <h4 className="font-semibold text-gray-800 mb-3">Configuración de pagos</h4>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Periodicidad</label>
                      <select value={newInstallationForm.tipoPago}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, tipoPago: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm">
                        <option value="mensual">Mensual</option>
                        <option value="trimestral">Trimestral</option>
                        <option value="anual">Anual</option>
                        <option value="unico">Pago único</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Importe (€)</label>
                      <input type="number" value={newInstallationForm.importeMensual}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, importeMensual: e.target.value})}
                        placeholder="0.00" className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Fecha prevista instalación</label>
                      <input type="date" value={newInstallationForm.fechaPrevistaInstalacion}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, fechaPrevistaInstalacion: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                    </div>
                  </div>
                </div>
              )}

              {/* TAB: Instalación */}
              {installationTab === 'instalacion' && (
                <div className="bg-gray-50 rounded-xl p-4 space-y-4">
                  <h4 className="font-semibold text-gray-800 mb-3">Detalles de la instalación</h4>

                  {/* Internet */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Internet</label>
                    <div className="flex gap-4">
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input type="radio" name="internetTipo" value="manantial"
                          checked={newInstallationForm.internetTipo === 'manantial'}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, internetTipo: e.target.value})}
                          className="w-4 h-4 text-blue-600" />
                        <span className="text-sm">De Manantial</span>
                      </label>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input type="radio" name="internetTipo" value="propio"
                          checked={newInstallationForm.internetTipo === 'propio'}
                          onChange={(e) => setNewInstallationForm({...newInstallationForm, internetTipo: e.target.value, tipoFibra: ''})}
                          className="w-4 h-4 text-blue-600" />
                        <span className="text-sm">Propio del cliente</span>
                      </label>
                    </div>
                  </div>

                  {/* Tipo de fibra (solo si es Manantial) */}
                  {newInstallationForm.internetTipo === 'manantial' && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de fibra</label>
                      <select value={newInstallationForm.tipoFibra}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, tipoFibra: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm">
                        <option value="">Seleccionar...</option>
                        <option value="ftth">FTTH (Fibra hasta el hogar)</option>
                        <option value="ftto">FTTO (Fibra hasta la oficina)</option>
                        <option value="hfc">HFC (Híbrido fibra-coaxial)</option>
                        <option value="4g">4G/LTE</option>
                        <option value="5g">5G</option>
                        <option value="otro">Otro</option>
                      </select>
                    </div>
                  )}

                  {/* Qué hay que llevar */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">¿Qué hay que llevar para la instalación?</label>
                    <textarea value={newInstallationForm.queLlevar}
                      onChange={(e) => setNewInstallationForm({...newInstallationForm, queLlevar: e.target.value})}
                      rows={3}
                      placeholder="Ordenador, router, cables, impresora térmica, datáfono..."
                      className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                  </div>

                  {/* Fechas */}
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Fecha prevista instalación</label>
                      <input type="date" value={newInstallationForm.fechaPrevistaInstalacion}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, fechaPrevistaInstalacion: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Fecha formación</label>
                      <input type="date" value={newInstallationForm.fechaFormacion}
                        onChange={(e) => setNewInstallationForm({...newInstallationForm, fechaFormacion: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm" />
                    </div>
                  </div>
                </div>
              )}

              {/* TAB: Archivos */}
              {installationTab === 'archivos' && (
                <div className="bg-gray-50 rounded-xl p-4 space-y-4">
                  <h4 className="font-semibold text-gray-800 mb-3">Archivos y notas</h4>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Subir archivos</label>
                    <div className="border-2 border-dashed border-gray-500 rounded-lg p-4 text-center hover:border-blue-400 cursor-pointer">
                      <input type="file" multiple onChange={(e) => {
                        const files = Array.from(e.target.files);
                        setNewInstallationForm({...newInstallationForm, archivos: [...newInstallationForm.archivos, ...files]});
                      }} className="hidden" id="install-files" />
                      <label htmlFor="install-files" className="cursor-pointer">
                        <FileText className="w-8 h-8 text-gray-400 mx-auto mb-2" />
                        <p className="text-sm text-gray-600">Click o arrastra archivos</p>
                      </label>
                    </div>
                    {newInstallationForm.archivos.length > 0 && (
                      <div className="mt-2 space-y-1">
                        {newInstallationForm.archivos.map((file, idx) => (
                          <div key={idx} className="flex items-center justify-between bg-white px-3 py-2 rounded border">
                            <span className="text-sm truncate">{file.name}</span>
                            <button onClick={() => {
                              const newArchivos = [...newInstallationForm.archivos];
                              newArchivos.splice(idx, 1);
                              setNewInstallationForm({...newInstallationForm, archivos: newArchivos});
                            }} className="text-red-500 hover:text-red-700">
                              <X className="w-4 h-4" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Notas</label>
                    <textarea value={newInstallationForm.notas}
                      onChange={(e) => setNewInstallationForm({...newInstallationForm, notas: e.target.value})}
                      placeholder="Observaciones..." rows={3}
                      className="w-full px-3 py-2 border border-gray-500 rounded-lg text-sm resize-none" />
                  </div>
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end gap-3 p-4 border-t bg-gray-50">
              <button onClick={() => setShowNewInstallation(false)}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg">
                Cancelar
              </button>
              <button
                onClick={async () => {
                  const f = newInstallationForm;
                  const token = localStorage.getItem('token');

                  try {
                    // Guardar en la API
                    const response = await fetch('/api/installations', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                      },
                      body: JSON.stringify(f)
                    });

                    if (!response.ok) {
                      throw new Error('Error guardando instalación');
                    }

                    // Recargar lista de instalaciones
                    loadInstallations();

                    // Comprobar campos opcionales pero importantes que faltan
                    const camposFaltantes = [];
                    if (!f.telefono.trim()) camposFaltantes.push('Teléfono');
                    if (!f.personaContacto.trim()) camposFaltantes.push('Persona de contacto');
                    if (!f.direccion.trim()) camposFaltantes.push('Dirección');
                    if (!f.materialInstalar.trim()) camposFaltantes.push('Material a instalar');
                    if (!f.importeMensual) camposFaltantes.push('Importe');
                    if (!f.fechaPrevistaInstalacion) camposFaltantes.push('Fecha prevista instalación');

                    // Si faltan campos, crear tarea automática
                    if (camposFaltantes.length > 0) {
                      await fetch('/api/tasks', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({
                          title: `Falta rellenar campos instalación ${f.idContrato || f.nombre}`,
                          description: `Campos pendientes:\n- ${camposFaltantes.join('\n- ')}`,
                          priority: 'medium',
                          due_date: new Date(Date.now() + 7*24*60*60*1000).toISOString(),
                          notes: `Instalación: ${f.nombre} (${f.localidad})`
                        })
                      });
                      loadTasks();
                    }

                    // Reset form
                    setNewInstallationForm({
                      idContrato: '', nombre: '', tipo: 'cine', localidad: '', provincia: '', direccion: '',
                      personaContacto: '', telefono: '', propietario: 'manantial',
                      fechaFirma: new Date().toISOString().split('T')[0], duracionContrato: '12',
                      expiraContrato: new Date(Date.now() + 365*24*60*60*1000).toISOString().split('T')[0],
                      crearAlarma: true, numAmpliaciones: 0, duracionAmpliacion: '12',
                      deptEntradas: false, deptDiseno: false, deptSAT: false, deptComercial: false, deptAdministracion: false,
                      materialInstalar: '', ponemosInternet: false, llevaPapel: false, tiposPapel: [],
                      cantidadPapel: '', llevaWeb: false, dineroDestino: 'manantial', tipoPago: 'mensual',
                      importeMensual: '', fechaPrevistaInstalacion: '', archivos: [], compartirCon: [], notas: ''
                    });
                    setInstallationTab('datos');
                    setShowNewInstallation(false);
                  } catch (err) {
                    console.error('Error guardando instalación:', err);
                    alert('Error al guardar la instalación');
                  }
                }}
                disabled={!isInstallationFormValid()}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed">
                Crear Instalación
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Popup de información de tarea */}
      {infoPopup && (
        <div
          className="fixed z-[100] bg-white rounded-xl shadow-xl border border-gray-500 p-4 max-w-md"
          style={{
            left: Math.min(infoPopup.x, window.innerWidth - 400),
            top: infoPopup.y,
            maxHeight: '200px',
            overflowY: 'auto'
          }}
          onMouseEnter={() => {}}
          onMouseLeave={() => setInfoPopup(null)}
        >
          <div className="flex items-start gap-2 mb-2">
            <Info className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
            <h4 className="font-semibold text-gray-900">Descripción de la tarea</h4>
          </div>
          <p className="text-sm text-gray-700 whitespace-pre-wrap">{infoPopup.description}</p>
        </div>
      )}

      {/* Modal de confirmación para archivar */}
      {archiveConfirm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setArchiveConfirm(null)}>
          <div className="bg-white rounded-xl shadow-2xl w-[380px] max-w-[90vw] overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between p-4 border-b bg-amber-50">
              <div className="flex items-center gap-2">
                <Archive className="w-5 h-5 text-amber-600" />
                <h3 className="text-lg font-semibold text-gray-900">¿Quieres archivar?</h3>
              </div>
              <button onClick={() => setArchiveConfirm(null)} className="p-1 hover:bg-amber-100 rounded">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-4">
              <p className="text-sm text-gray-600">
                <span className="font-medium">
                  {archiveConfirm.type === 'task' ? 'Tarea' : archiveConfirm.type === 'job' ? 'Trabajo' : archiveConfirm.type === 'installation' ? 'Instalación' : 'Nota'}:
                </span>{' '}
                <span className="text-gray-900">{archiveConfirm.item.title || archiveConfirm.item.nombre || archiveConfirm.item.text?.slice(0, 50)}</span>
              </p>
              <p className="text-sm text-gray-500 mt-2">
                Esta acción moverá el elemento al historial de completados.
              </p>
            </div>
            <div className="flex justify-end gap-2 p-4 border-t bg-gray-50">
              <button
                onClick={() => setArchiveConfirm(null)}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  if (archiveConfirm.type === 'note') {
                    // Notas se archivan directamente sin pedir tiempo
                    toggleNoteCompleted(archiveConfirm.item.id);
                    setArchiveConfirm(null);
                  } else {
                    // Tareas, trabajos e instalaciones piden tiempo
                    setCompletionModal({ type: archiveConfirm.type, item: archiveConfirm.item });
                    setArchiveConfirm(null);
                  }
                }}
                className="px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors flex items-center gap-2"
              >
                <Archive className="w-4 h-4" />
                Sí, archivar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para marcar como completado con tiempo */}
      {completionModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => { setCompletionModal(null); setCompletionTime(''); }}>
          <div className="bg-white rounded-xl shadow-2xl w-[400px] max-w-[90vw] overflow-hidden" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between p-4 border-b bg-green-50">
              <div className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-600" />
                <h3 className="text-lg font-semibold text-gray-900">Marcar como completado</h3>
              </div>
              <button onClick={() => { setCompletionModal(null); setCompletionTime(''); }} className="p-1 hover:bg-green-100 rounded">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-4 space-y-4">
              <p className="text-sm text-gray-600">
                <span className="font-medium">
                  {completionModal.type === 'task' ? 'Tarea' : completionModal.type === 'job' ? 'Trabajo' : 'Instalación'}:
                </span>{' '}
                {completionModal.item.title || completionModal.item.nombre}
              </p>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  <Clock className="w-4 h-4 inline mr-1" />
                  Tiempo invertido (minutos)
                </label>
                <input
                  type="number"
                  value={completionTime}
                  onChange={(e) => setCompletionTime(e.target.value)}
                  placeholder="Ej: 30"
                  min="1"
                  className="w-full px-3 py-2 border border-gray-500 rounded-lg focus:outline-none focus:border-green-500"
                  autoFocus
                />
              </div>
            </div>
            <div className="flex justify-end gap-2 p-4 border-t bg-gray-50">
              <button
                onClick={() => { setCompletionModal(null); setCompletionTime(''); }}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  const timeInMinutes = parseInt(completionTime) || 0;
                  if (completionModal.type === 'task') {
                    updateTaskStatus(completionModal.item.id, 'completed', timeInMinutes);
                  } else if (completionModal.type === 'job') {
                    updateJobStatus(completionModal.item.id, 'completed', timeInMinutes);
                  } else if (completionModal.type === 'installation') {
                    updateInstallationStatus(completionModal.item.id, 'completed', timeInMinutes);
                  }
                  setCompletionModal(null);
                  setCompletionTime('');
                }}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center gap-2"
              >
                <CheckCircle2 className="w-4 h-4" />
                Completar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
